function PlanW({ ...props }) {
	return (
		<g {...props} id="unit-w">
			<g id="furniture">
				<polyline
					points="142.72 557.74 145.09 557.74 145.09 562.43 142.72 562.43 142.72 557.74"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="564.43"
					y1="726.95"
					x2="412.9"
					y2="726.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="564.43"
					y1="735.12"
					x2="564.43"
					y2="729.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="564.43"
					y1="729.33"
					x2="558.79"
					y2="729.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.37"
					y1="729.33"
					x2="549.66"
					y2="729.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="546.24"
					y1="729.33"
					x2="540.54"
					y2="729.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="537.12"
					y1="729.33"
					x2="531.42"
					y2="729.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="528"
					y1="729.33"
					x2="522.3"
					y2="729.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="518.88"
					y1="729.33"
					x2="513.18"
					y2="729.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="509.76"
					y1="729.33"
					x2="504.06"
					y2="729.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="500.64"
					y1="729.33"
					x2="494.93"
					y2="729.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="491.51"
					y1="729.33"
					x2="485.81"
					y2="729.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="482.39"
					y1="729.33"
					x2="476.69"
					y2="729.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="473.27"
					y1="729.33"
					x2="467.57"
					y2="729.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="464.15"
					y1="729.33"
					x2="458.45"
					y2="729.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="455.03"
					y1="729.33"
					x2="449.32"
					y2="729.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="445.9"
					y1="729.33"
					x2="440.21"
					y2="729.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="436.78"
					y1="729.33"
					x2="431.08"
					y2="729.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="427.66"
					y1="729.33"
					x2="421.96"
					y2="729.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="418.54"
					y1="729.33"
					x2="412.9"
					y2="729.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="412.9"
					y1="729.33"
					x2="412.9"
					y2="735.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="568.63 97.61 532.56 97.61 532.56 102.76 568.63 102.76 568.63 97.61"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="530.69 97.14 570.51 97.14 570.51 97.61 530.69 97.61 530.69 97.14"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="530.69"
					y1="97.14"
					x2="570.51"
					y2="97.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="570.51"
					y1="97.14"
					x2="570.51"
					y2="97.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="570.51"
					y1="97.61"
					x2="530.69"
					y2="97.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="530.69"
					y1="97.61"
					x2="530.69"
					y2="97.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="568.63"
					y1="102.76"
					x2="532.56"
					y2="102.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="532.56"
					y1="97.61"
					x2="568.63"
					y2="97.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="572.84 102.76 568.63 102.76 568.63 97.61 572.84 97.61 572.84 102.76"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="572.84"
					y1="102.76"
					x2="568.63"
					y2="102.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="568.63"
					y1="102.76"
					x2="568.63"
					y2="97.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="568.63"
					y1="97.61"
					x2="572.84"
					y2="97.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="572.84"
					y1="97.61"
					x2="572.84"
					y2="102.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="528.35 97.61 532.56 97.61 532.56 102.76 528.35 102.76 528.35 97.61"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="528.35"
					y1="97.61"
					x2="532.56"
					y2="97.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="532.56"
					y1="97.61"
					x2="532.56"
					y2="102.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="532.56"
					y1="102.76"
					x2="528.35"
					y2="102.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="528.35"
					y1="102.76"
					x2="528.35"
					y2="97.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="568.63"
					y1="98.55"
					x2="532.56"
					y2="98.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="574.71 102.29 572.84 102.29 572.84 97.61 570.51 97.61 570.51 97.14 574.71 97.14 574.71 102.29"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="574.71"
					y1="102.29"
					x2="572.84"
					y2="102.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="572.84"
					y1="102.29"
					x2="572.84"
					y2="97.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="572.84"
					y1="97.61"
					x2="570.51"
					y2="97.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="570.51"
					y1="97.61"
					x2="570.51"
					y2="97.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="570.51"
					y1="97.14"
					x2="574.71"
					y2="97.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="574.71"
					y1="97.14"
					x2="574.71"
					y2="102.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="526.48 97.14 530.69 97.14 530.69 97.61 528.35 97.61 528.35 102.29 526.48 102.29 526.48 97.14"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="526.48"
					y1="97.14"
					x2="530.69"
					y2="97.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="530.69"
					y1="97.14"
					x2="530.69"
					y2="97.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="530.69"
					y1="97.61"
					x2="528.35"
					y2="97.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="528.35"
					y1="97.61"
					x2="528.35"
					y2="102.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="528.35"
					y1="102.29"
					x2="526.48"
					y2="102.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="526.48"
					y1="102.29"
					x2="526.48"
					y2="97.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="524.1 98.55 524.1 100.92 439.58 100.92 439.58 98.55 524.1 98.55"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="524.1"
					y1="98.55"
					x2="524.1"
					y2="100.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="524.1"
					y1="100.92"
					x2="439.58"
					y2="100.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="439.58"
					y1="100.92"
					x2="439.58"
					y2="98.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="439.58"
					y1="98.55"
					x2="524.1"
					y2="98.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="574.71 98.55 579.46 98.55 579.46 112.8 574.71 112.8 574.71 98.55"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="579.46"
					y1="98.55"
					x2="574.71"
					y2="98.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="579.46"
					y1="112.8"
					x2="579.46"
					y2="98.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="574.71"
					y1="112.8"
					x2="579.46"
					y2="112.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="574.71"
					y1="98.55"
					x2="574.71"
					y2="112.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="521.73 98.55 526.48 98.55 526.48 112.8 521.73 112.8 521.73 98.55"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="526.48"
					y1="98.55"
					x2="521.73"
					y2="98.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="526.48"
					y1="112.8"
					x2="526.48"
					y2="98.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="521.73"
					y1="112.8"
					x2="526.48"
					y2="112.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="521.73"
					y1="98.55"
					x2="521.73"
					y2="112.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="437.2 98.55 441.96 98.55 441.96 112.8 437.2 112.8 437.2 98.55"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="441.96"
					y1="98.55"
					x2="437.2"
					y2="98.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="441.96"
					y1="112.8"
					x2="441.96"
					y2="98.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="437.2"
					y1="112.8"
					x2="441.96"
					y2="112.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="437.2"
					y1="98.55"
					x2="437.2"
					y2="112.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="853.02 97.61 814.57 97.61 814.57 102.76 853.02 102.76 853.02 97.61"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="812.7 97.14 854.89 97.14 854.89 97.61 812.7 97.61 812.7 97.14"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="812.7"
					y1="97.14"
					x2="854.89"
					y2="97.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="854.89"
					y1="97.14"
					x2="854.89"
					y2="97.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="854.89"
					y1="97.61"
					x2="812.7"
					y2="97.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="812.7"
					y1="97.61"
					x2="812.7"
					y2="97.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="853.02"
					y1="102.76"
					x2="814.57"
					y2="102.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="814.57"
					y1="97.61"
					x2="853.02"
					y2="97.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="857.23 102.76 853.02 102.76 853.02 97.61 857.23 97.61 857.23 102.76"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="857.23"
					y1="102.76"
					x2="853.02"
					y2="102.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="853.02"
					y1="102.76"
					x2="853.02"
					y2="97.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="853.02"
					y1="97.61"
					x2="857.23"
					y2="97.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="857.23"
					y1="97.61"
					x2="857.23"
					y2="102.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="810.36 97.61 814.57 97.61 814.57 102.76 810.36 102.76 810.36 97.61"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="810.36"
					y1="97.61"
					x2="814.57"
					y2="97.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="814.57"
					y1="97.61"
					x2="814.57"
					y2="102.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="814.57"
					y1="102.76"
					x2="810.36"
					y2="102.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="810.36"
					y1="102.76"
					x2="810.36"
					y2="97.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="853.02"
					y1="98.55"
					x2="814.57"
					y2="98.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="859.1 102.29 857.23 102.29 857.23 97.61 854.89 97.61 854.89 97.14 859.1 97.14 859.1 102.29"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="859.1"
					y1="102.29"
					x2="857.23"
					y2="102.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="857.23"
					y1="102.29"
					x2="857.23"
					y2="97.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="857.23"
					y1="97.61"
					x2="854.89"
					y2="97.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="854.89"
					y1="97.61"
					x2="854.89"
					y2="97.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="854.89"
					y1="97.14"
					x2="859.1"
					y2="97.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="859.1"
					y1="97.14"
					x2="859.1"
					y2="102.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="808.49 97.14 812.7 97.14 812.7 97.61 810.36 97.61 810.36 102.29 808.49 102.29 808.49 97.14"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="808.49"
					y1="97.14"
					x2="812.7"
					y2="97.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="812.7"
					y1="97.14"
					x2="812.7"
					y2="97.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="812.7"
					y1="97.61"
					x2="810.36"
					y2="97.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="810.36"
					y1="97.61"
					x2="810.36"
					y2="102.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="810.36"
					y1="102.29"
					x2="808.49"
					y2="102.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="808.49"
					y1="102.29"
					x2="808.49"
					y2="97.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="806.12 98.55 806.12 100.92 710.55 100.92 710.55 98.55 806.12 98.55"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="806.12"
					y1="98.55"
					x2="806.12"
					y2="100.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="806.12"
					y1="100.92"
					x2="710.55"
					y2="100.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="710.55"
					y1="100.92"
					x2="710.55"
					y2="98.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="710.55"
					y1="98.55"
					x2="806.12"
					y2="98.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="859.1 98.55 863.85 98.55 863.85 112.8 859.1 112.8 859.1 98.55"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="863.85"
					y1="98.55"
					x2="859.1"
					y2="98.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="863.85"
					y1="112.8"
					x2="863.85"
					y2="98.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="859.1"
					y1="112.8"
					x2="863.85"
					y2="112.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="859.1"
					y1="98.55"
					x2="859.1"
					y2="112.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="803.74 98.55 808.49 98.55 808.49 112.8 803.74 112.8 803.74 98.55"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="808.49"
					y1="98.55"
					x2="803.74"
					y2="98.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="808.49"
					y1="112.8"
					x2="808.49"
					y2="98.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="803.74"
					y1="112.8"
					x2="808.49"
					y2="112.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="803.74"
					y1="98.55"
					x2="803.74"
					y2="112.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="708.17 98.55 712.93 98.55 712.93 112.8 708.17 112.8 708.17 98.55"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="712.93"
					y1="98.55"
					x2="708.17"
					y2="98.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="712.93"
					y1="112.8"
					x2="712.93"
					y2="98.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.17"
					y1="112.8"
					x2="712.93"
					y2="112.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.17"
					y1="98.55"
					x2="708.17"
					y2="112.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="437.2"
					y1="93.8"
					x2="437.2"
					y2="112.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="876.76"
					y1="762.58"
					x2="736.93"
					y2="762.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="329.79"
					y1="886.01"
					x2="329.79"
					y2="905.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="239.52"
					y1="905.01"
					x2="235.96"
					y2="905.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="239.52"
					y1="886.01"
					x2="235.96"
					y2="886.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="239.52"
					y1="886.01"
					x2="239.52"
					y2="905.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="240.71 906.2 240.71 905.01 235.96 905.01 235.96 906.2 240.71 906.2"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="240.71 886.01 240.71 884.82 235.96 884.82 235.96 886.01 240.71 886.01"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="240.71"
					y1="906.2"
					x2="235.96"
					y2="906.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.96"
					y1="906.2"
					x2="235.96"
					y2="905.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.96"
					y1="905.01"
					x2="240.71"
					y2="905.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="240.71"
					y1="905.01"
					x2="240.71"
					y2="906.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="328.6"
					y1="906.2"
					x2="328.6"
					y2="905.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="240.71"
					y1="886.01"
					x2="235.96"
					y2="886.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.96"
					y1="886.01"
					x2="235.96"
					y2="884.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.96"
					y1="884.82"
					x2="240.71"
					y2="884.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="240.71"
					y1="884.82"
					x2="240.71"
					y2="886.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="328.6"
					y1="886.01"
					x2="328.6"
					y2="884.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="241.9 905.01 241.9 886.01 240.12 886.01 240.12 905.01 241.9 905.01"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="329.2 905.01 329.2 886.01 327.41 886.01 327.41 905.01 329.2 905.01"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="266.95 825.54 264.01 828.48 324.47 888.95 327.41 886.01 266.95 825.54"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="240.12"
					y1="886.01"
					x2="239.52"
					y2="886.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="240.12"
					y1="905.01"
					x2="239.52"
					y2="905.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="239.52"
					y1="886.01"
					x2="239.52"
					y2="905.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="329.2"
					y1="886.01"
					x2="329.79"
					y2="886.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="329.2"
					y1="905.01"
					x2="329.79"
					y2="905.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="329.79"
					y1="886.01"
					x2="329.79"
					y2="905.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="241.9"
					y1="905.01"
					x2="241.9"
					y2="886.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="241.9"
					y1="886.01"
					x2="240.12"
					y2="886.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="240.12"
					y1="886.01"
					x2="240.12"
					y2="905.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="240.12"
					y1="905.01"
					x2="241.9"
					y2="905.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="329.2"
					y1="905.01"
					x2="329.2"
					y2="886.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="329.2"
					y1="886.01"
					x2="327.41"
					y2="886.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="327.41"
					y1="886.01"
					x2="327.41"
					y2="905.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="327.41"
					y1="905.01"
					x2="329.2"
					y2="905.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="266.95"
					y1="825.54"
					x2="264.01"
					y2="828.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="264.01"
					y1="828.48"
					x2="324.47"
					y2="888.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="324.47"
					y1="888.95"
					x2="327.41"
					y2="886.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="327.41"
					y1="886.01"
					x2="266.95"
					y2="825.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="239.52"
					y1="886.01"
					x2="239.52"
					y2="905.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="239.52"
					y1="886.01"
					x2="239.52"
					y2="905.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="239.52"
					y1="886.01"
					x2="235.96"
					y2="886.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="239.52"
					y1="886.01"
					x2="235.96"
					y2="886.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="239.52"
					y1="905.01"
					x2="235.96"
					y2="905.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="239.52"
					y1="905.01"
					x2="235.96"
					y2="905.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="329.79"
					y1="886.01"
					x2="329.79"
					y2="905.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="329.79"
					y1="886.01"
					x2="329.79"
					y2="905.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.99"
					y1="492.55"
					x2="386.11"
					y2="492.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="147.47"
					y1="492.55"
					x2="386.11"
					y2="492.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="147.47"
					y1="492.55"
					x2="147.47"
					y2="480.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="147.47"
					y1="469.17"
					x2="147.47"
					y2="480.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="582.43"
					y1="540.56"
					x2="586"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="582.43"
					y1="528.69"
					x2="586"
					y2="528.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="582.43"
					y1="528.69"
					x2="582.43"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.42"
					y1="540.56"
					x2="502.86"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.42"
					y1="528.69"
					x2="502.86"
					y2="528.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.42"
					y1="528.69"
					x2="506.42"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.21"
					y1="540.56"
					x2="613.65"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.21"
					y1="528.69"
					x2="613.65"
					y2="528.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.21"
					y1="528.69"
					x2="617.21"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="693.23"
					y1="540.56"
					x2="696.79"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="693.23"
					y1="528.69"
					x2="696.79"
					y2="528.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="693.23"
					y1="528.69"
					x2="693.23"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="693.23"
					y1="540.56"
					x2="725.05"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.93"
					y1="540.56"
					x2="895.18"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="507.61 541.75 507.61 540.56 502.86 540.56 502.86 541.75 507.61 541.75"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="581.25 540.56 581.25 541.75 586 541.75 586 540.56 581.25 540.56"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="507.61 528.69 507.61 527.5 502.86 527.5 502.86 528.69 507.61 528.69"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="581.25 527.5 581.25 528.69 586 528.69 586 527.5 581.25 527.5"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="507.61"
					y1="541.75"
					x2="502.86"
					y2="541.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.86"
					y1="541.75"
					x2="502.86"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.86"
					y1="540.56"
					x2="507.61"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="507.61"
					y1="540.56"
					x2="507.61"
					y2="541.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="581.25"
					y1="540.56"
					x2="586"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586"
					y1="540.56"
					x2="586"
					y2="541.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586"
					y1="541.75"
					x2="581.25"
					y2="541.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="581.25"
					y1="541.75"
					x2="581.25"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="507.61"
					y1="528.69"
					x2="502.86"
					y2="528.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.86"
					y1="528.69"
					x2="502.86"
					y2="527.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.86"
					y1="527.5"
					x2="507.61"
					y2="527.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="507.61"
					y1="527.5"
					x2="507.61"
					y2="528.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="581.25"
					y1="527.5"
					x2="586"
					y2="527.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586"
					y1="527.5"
					x2="586"
					y2="528.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586"
					y1="528.69"
					x2="581.25"
					y2="528.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="581.25"
					y1="528.69"
					x2="581.25"
					y2="527.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="508.79 540.56 508.79 528.69 507.01 528.69 507.01 540.56 508.79 540.56"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="581.84 540.56 581.84 528.69 580.06 528.69 580.06 540.56 581.84 540.56"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="529.67 478.3 526.73 481.24 577.12 531.63 580.06 528.69 529.67 478.3"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="507.01"
					y1="528.69"
					x2="506.42"
					y2="528.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="507.01"
					y1="540.56"
					x2="506.42"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.42"
					y1="528.69"
					x2="506.42"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="581.84"
					y1="528.69"
					x2="582.43"
					y2="528.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="581.84"
					y1="540.56"
					x2="582.43"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="582.43"
					y1="528.69"
					x2="582.43"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="508.79"
					y1="540.56"
					x2="508.79"
					y2="528.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="508.79"
					y1="528.69"
					x2="507.01"
					y2="528.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="507.01"
					y1="528.69"
					x2="507.01"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="507.01"
					y1="540.56"
					x2="508.79"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="581.84"
					y1="540.56"
					x2="581.84"
					y2="528.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="581.84"
					y1="528.69"
					x2="580.06"
					y2="528.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="580.06"
					y1="528.69"
					x2="580.06"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="580.06"
					y1="540.56"
					x2="581.84"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.67"
					y1="478.3"
					x2="526.73"
					y2="481.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="526.73"
					y1="481.24"
					x2="577.12"
					y2="531.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="577.12"
					y1="531.63"
					x2="580.06"
					y2="528.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="580.06"
					y1="528.69"
					x2="529.67"
					y2="478.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.42"
					y1="528.69"
					x2="506.42"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.42"
					y1="528.69"
					x2="506.42"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.42"
					y1="528.69"
					x2="502.86"
					y2="528.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.42"
					y1="528.69"
					x2="502.86"
					y2="528.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.42"
					y1="540.56"
					x2="502.86"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.42"
					y1="540.56"
					x2="502.86"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="582.43"
					y1="528.69"
					x2="582.43"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="582.43"
					y1="528.69"
					x2="582.43"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="582.43"
					y1="528.69"
					x2="586"
					y2="528.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="582.43"
					y1="528.69"
					x2="586"
					y2="528.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="582.43"
					y1="540.56"
					x2="586"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="582.43"
					y1="540.56"
					x2="586"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="692.04 541.75 696.79 541.75 696.79 540.56 692.04 540.56 692.04 541.75"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="618.4 540.56 613.65 540.56 613.65 541.75 618.4 541.75 618.4 540.56"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="692.04 528.69 696.79 528.69 696.79 527.5 692.04 527.5 692.04 528.69"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="618.4 527.5 613.65 527.5 613.65 528.69 618.4 528.69 618.4 527.5"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="692.04"
					y1="541.75"
					x2="696.79"
					y2="541.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="696.79"
					y1="541.75"
					x2="696.79"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="696.79"
					y1="540.56"
					x2="692.04"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="692.04"
					y1="540.56"
					x2="692.04"
					y2="541.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="618.4"
					y1="540.56"
					x2="613.65"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="613.65"
					y1="540.56"
					x2="613.65"
					y2="541.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="613.65"
					y1="541.75"
					x2="618.4"
					y2="541.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="618.4"
					y1="541.75"
					x2="618.4"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="692.04"
					y1="528.69"
					x2="696.79"
					y2="528.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="696.79"
					y1="528.69"
					x2="696.79"
					y2="527.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="696.79"
					y1="527.5"
					x2="692.04"
					y2="527.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="692.04"
					y1="527.5"
					x2="692.04"
					y2="528.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="618.4"
					y1="527.5"
					x2="613.65"
					y2="527.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="613.65"
					y1="527.5"
					x2="613.65"
					y2="528.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="613.65"
					y1="528.69"
					x2="618.4"
					y2="528.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="618.4"
					y1="528.69"
					x2="618.4"
					y2="527.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="690.85 540.56 692.63 540.56 692.63 528.69 690.85 528.69 690.85 540.56"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="617.81 540.56 619.59 540.56 619.59 528.69 617.81 528.69 617.81 540.56"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="669.98 478.3 619.59 528.69 622.53 531.63 672.92 481.24 669.98 478.3"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="692.63"
					y1="528.69"
					x2="693.23"
					y2="528.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="692.63"
					y1="540.56"
					x2="693.23"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="693.23"
					y1="528.69"
					x2="693.23"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.81"
					y1="528.69"
					x2="617.21"
					y2="528.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.81"
					y1="540.56"
					x2="617.21"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.21"
					y1="528.69"
					x2="617.21"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="690.85"
					y1="540.56"
					x2="690.85"
					y2="528.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="690.85"
					y1="528.69"
					x2="692.63"
					y2="528.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="692.63"
					y1="528.69"
					x2="692.63"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="692.63"
					y1="540.56"
					x2="690.85"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.81"
					y1="540.56"
					x2="617.81"
					y2="528.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.81"
					y1="528.69"
					x2="619.59"
					y2="528.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="619.59"
					y1="528.69"
					x2="619.59"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="619.59"
					y1="540.56"
					x2="617.81"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="669.98"
					y1="478.3"
					x2="672.92"
					y2="481.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="672.92"
					y1="481.24"
					x2="622.53"
					y2="531.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="622.53"
					y1="531.63"
					x2="619.59"
					y2="528.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="619.59"
					y1="528.69"
					x2="669.98"
					y2="478.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="693.23"
					y1="528.69"
					x2="693.23"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="693.23"
					y1="528.69"
					x2="693.23"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="693.23"
					y1="528.69"
					x2="696.79"
					y2="528.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="693.23"
					y1="528.69"
					x2="696.79"
					y2="528.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="693.23"
					y1="540.56"
					x2="696.79"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="693.23"
					y1="540.56"
					x2="696.79"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.21"
					y1="528.69"
					x2="617.21"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.21"
					y1="528.69"
					x2="617.21"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.21"
					y1="528.69"
					x2="613.65"
					y2="528.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.21"
					y1="528.69"
					x2="613.65"
					y2="528.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.21"
					y1="540.56"
					x2="613.65"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.21"
					y1="540.56"
					x2="613.65"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="699.72"
					y1="190.08"
					x2="699.72"
					y2="178.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="699.72"
					y1="178.2"
					x2="699.72"
					y2="112.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.05"
					y1="552.73"
					x2="725.05"
					y2="549.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.93"
					y1="552.73"
					x2="736.93"
					y2="549.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.93"
					y1="552.73"
					x2="725.05"
					y2="552.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.05"
					y1="628.74"
					x2="725.05"
					y2="632.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.93"
					y1="628.74"
					x2="736.93"
					y2="632.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.93"
					y1="628.74"
					x2="725.05"
					y2="628.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.93"
					y1="762.58"
					x2="736.93"
					y2="628.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.93"
					y1="552.73"
					x2="736.93"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.05"
					y1="540.56"
					x2="725.05"
					y2="552.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.05"
					y1="628.74"
					x2="725.05"
					y2="671.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="723.86 627.56 723.86 632.31 725.05 632.31 725.05 627.56 723.86 627.56"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="725.05 553.92 725.05 549.16 723.86 549.16 723.86 553.92 725.05 553.92"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="736.93 627.56 736.93 632.31 738.12 632.31 738.12 627.56 736.93 627.56"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="738.12 553.92 738.12 549.16 736.93 549.16 736.93 553.92 738.12 553.92"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="723.86"
					y1="627.56"
					x2="723.86"
					y2="632.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="723.86"
					y1="632.31"
					x2="725.05"
					y2="632.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.05"
					y1="632.31"
					x2="725.05"
					y2="627.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.05"
					y1="627.56"
					x2="723.86"
					y2="627.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.05"
					y1="553.92"
					x2="725.05"
					y2="549.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.05"
					y1="549.16"
					x2="723.86"
					y2="549.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="723.86"
					y1="549.16"
					x2="723.86"
					y2="553.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="723.86"
					y1="553.92"
					x2="725.05"
					y2="553.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.93"
					y1="627.56"
					x2="736.93"
					y2="632.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.93"
					y1="632.31"
					x2="738.12"
					y2="632.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="738.12"
					y1="632.31"
					x2="738.12"
					y2="627.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="738.12"
					y1="627.56"
					x2="736.93"
					y2="627.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="738.12"
					y1="553.92"
					x2="738.12"
					y2="549.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="738.12"
					y1="549.16"
					x2="736.93"
					y2="549.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.93"
					y1="549.16"
					x2="736.93"
					y2="553.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.93"
					y1="553.92"
					x2="738.12"
					y2="553.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="725.05 626.37 725.05 628.15 736.93 628.15 736.93 626.37 725.05 626.37"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="725.05 553.32 725.05 555.1 736.93 555.1 736.93 553.32 725.05 553.32"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="787.32 605.5 736.93 555.1 733.99 558.04 784.38 608.43 787.32 605.5"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="736.93"
					y1="628.15"
					x2="736.93"
					y2="628.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.05"
					y1="628.15"
					x2="725.05"
					y2="628.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.93"
					y1="628.74"
					x2="725.05"
					y2="628.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.93"
					y1="553.32"
					x2="736.93"
					y2="552.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.05"
					y1="553.32"
					x2="725.05"
					y2="552.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.93"
					y1="552.73"
					x2="725.05"
					y2="552.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.05"
					y1="626.37"
					x2="736.93"
					y2="626.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.93"
					y1="626.37"
					x2="736.93"
					y2="628.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.93"
					y1="628.15"
					x2="725.05"
					y2="628.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.05"
					y1="628.15"
					x2="725.05"
					y2="626.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.05"
					y1="553.32"
					x2="736.93"
					y2="553.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.93"
					y1="553.32"
					x2="736.93"
					y2="555.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.93"
					y1="555.1"
					x2="725.05"
					y2="555.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.05"
					y1="555.1"
					x2="725.05"
					y2="553.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="787.32"
					y1="605.5"
					x2="784.38"
					y2="608.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="784.38"
					y1="608.43"
					x2="733.99"
					y2="558.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="733.99"
					y1="558.04"
					x2="736.93"
					y2="555.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.93"
					y1="555.1"
					x2="787.32"
					y2="605.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.93"
					y1="628.74"
					x2="725.05"
					y2="628.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.93"
					y1="628.74"
					x2="725.05"
					y2="628.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.93"
					y1="628.74"
					x2="736.93"
					y2="632.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.93"
					y1="628.74"
					x2="736.93"
					y2="632.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.05"
					y1="628.74"
					x2="725.05"
					y2="632.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.05"
					y1="628.74"
					x2="725.05"
					y2="632.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.93"
					y1="552.73"
					x2="725.05"
					y2="552.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.93"
					y1="552.73"
					x2="725.05"
					y2="552.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.93"
					y1="552.73"
					x2="736.93"
					y2="549.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.93"
					y1="552.73"
					x2="736.93"
					y2="549.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.05"
					y1="552.73"
					x2="725.05"
					y2="549.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.05"
					y1="552.73"
					x2="725.05"
					y2="549.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="876.76"
					y1="687.92"
					x2="876.76"
					y2="762.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="876.76"
					y1="687.92"
					x2="888.64"
					y2="687.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="895.18"
					y1="687.92"
					x2="888.64"
					y2="687.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="895.18"
					y1="540.56"
					x2="895.18"
					y2="687.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="683.76"
					y1="683.14"
					x2="683.76"
					y2="762.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="679.54"
					y1="683.14"
					x2="683.1"
					y2="683.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="679.54"
					y1="671.26"
					x2="683.1"
					y2="671.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="679.54"
					y1="671.26"
					x2="679.54"
					y2="683.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.78"
					y1="683.14"
					x2="614.21"
					y2="683.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.78"
					y1="671.26"
					x2="614.21"
					y2="671.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.78"
					y1="671.26"
					x2="617.78"
					y2="683.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="683.76"
					y1="671.26"
					x2="679.54"
					y2="671.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="613.35"
					y1="683.14"
					x2="617.78"
					y2="683.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="679.54"
					y1="683.14"
					x2="683.76"
					y2="683.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="618.96 684.32 618.96 683.14 614.21 683.14 614.21 684.32 618.96 684.32"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="678.35 683.14 678.35 684.32 683.1 684.32 683.1 683.14 678.35 683.14"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="618.96 671.26 618.96 670.07 614.21 670.07 614.21 671.26 618.96 671.26"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="678.35 670.07 678.35 671.26 683.1 671.26 683.1 670.07 678.35 670.07"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="618.96"
					y1="684.32"
					x2="614.21"
					y2="684.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="614.21"
					y1="684.32"
					x2="614.21"
					y2="683.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="614.21"
					y1="683.14"
					x2="618.96"
					y2="683.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="618.96"
					y1="683.14"
					x2="618.96"
					y2="684.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="678.35"
					y1="683.14"
					x2="683.1"
					y2="683.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="683.1"
					y1="683.14"
					x2="683.1"
					y2="684.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="683.1"
					y1="684.32"
					x2="678.35"
					y2="684.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="678.35"
					y1="684.32"
					x2="678.35"
					y2="683.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="618.96"
					y1="671.26"
					x2="614.21"
					y2="671.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="614.21"
					y1="671.26"
					x2="614.21"
					y2="670.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="614.21"
					y1="670.07"
					x2="618.96"
					y2="670.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="618.96"
					y1="670.07"
					x2="618.96"
					y2="671.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="678.35"
					y1="670.07"
					x2="683.1"
					y2="670.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="683.1"
					y1="670.07"
					x2="683.1"
					y2="671.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="683.1"
					y1="671.26"
					x2="678.35"
					y2="671.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="678.35"
					y1="671.26"
					x2="678.35"
					y2="670.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="620.15 683.14 620.15 671.26 618.37 671.26 618.37 683.14 620.15 683.14"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="678.94 683.14 678.94 671.26 677.16 671.26 677.16 683.14 678.94 683.14"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="636.85 630.94 633.91 633.88 674.22 674.2 677.16 671.26 636.85 630.94"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="618.37"
					y1="671.26"
					x2="617.78"
					y2="671.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="618.37"
					y1="683.14"
					x2="617.78"
					y2="683.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.78"
					y1="671.26"
					x2="617.78"
					y2="683.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="678.94"
					y1="671.26"
					x2="679.54"
					y2="671.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="678.94"
					y1="683.14"
					x2="679.54"
					y2="683.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="679.54"
					y1="671.26"
					x2="679.54"
					y2="683.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="620.15"
					y1="683.14"
					x2="620.15"
					y2="671.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="620.15"
					y1="671.26"
					x2="618.37"
					y2="671.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="618.37"
					y1="671.26"
					x2="618.37"
					y2="683.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="618.37"
					y1="683.14"
					x2="620.15"
					y2="683.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="678.94"
					y1="683.14"
					x2="678.94"
					y2="671.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="678.94"
					y1="671.26"
					x2="677.16"
					y2="671.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="677.16"
					y1="671.26"
					x2="677.16"
					y2="683.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="677.16"
					y1="683.14"
					x2="678.94"
					y2="683.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="636.85"
					y1="630.94"
					x2="633.91"
					y2="633.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="633.91"
					y1="633.88"
					x2="674.22"
					y2="674.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="674.22"
					y1="674.2"
					x2="677.16"
					y2="671.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="677.16"
					y1="671.26"
					x2="636.85"
					y2="630.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.78"
					y1="671.26"
					x2="617.78"
					y2="683.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.78"
					y1="671.26"
					x2="617.78"
					y2="683.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.78"
					y1="671.26"
					x2="614.21"
					y2="671.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.78"
					y1="671.26"
					x2="614.21"
					y2="671.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.78"
					y1="683.14"
					x2="614.21"
					y2="683.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.78"
					y1="683.14"
					x2="614.21"
					y2="683.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="679.54"
					y1="671.26"
					x2="679.54"
					y2="683.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="679.54"
					y1="671.26"
					x2="679.54"
					y2="683.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="679.54"
					y1="671.26"
					x2="683.1"
					y2="671.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="679.54"
					y1="671.26"
					x2="683.1"
					y2="671.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="679.54"
					y1="683.14"
					x2="683.1"
					y2="683.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="679.54"
					y1="683.14"
					x2="683.1"
					y2="683.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="564.43"
					y1="671.26"
					x2="564.43"
					y2="683.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="564.43"
					y1="683.14"
					x2="564.43"
					y2="693.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="431.52"
					y1="705.7"
					x2="428.54"
					y2="705.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="431.52"
					y1="703.33"
					x2="431.52"
					y2="705.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="431.52"
					y1="693.83"
					x2="428.54"
					y2="693.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="431.52"
					y1="693.83"
					x2="431.52"
					y2="703.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="556.23"
					y1="705.7"
					x2="559.19"
					y2="705.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="556.23"
					y1="703.33"
					x2="556.23"
					y2="705.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="556.23"
					y1="693.83"
					x2="559.19"
					y2="693.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="556.23"
					y1="693.83"
					x2="556.23"
					y2="703.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="412.9"
					y1="705.7"
					x2="431.52"
					y2="705.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="556.23"
					y1="705.7"
					x2="564.43"
					y2="705.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="564.43"
					y1="693.83"
					x2="556.23"
					y2="693.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="401.02"
					y1="693.83"
					x2="412.9"
					y2="693.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="431.52"
					y1="693.83"
					x2="412.9"
					y2="693.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="554.44 703.33 554.44 705.7 555.63 705.7 555.63 703.33 554.44 703.33"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="554.44 706.89 559.19 706.89 559.19 705.7 554.44 705.7 554.44 706.89"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="432.11 703.33 432.11 705.7 433.29 705.7 433.29 703.33 432.11 703.33"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="433.29 705.7 428.54 705.7 428.54 706.89 433.29 706.89 433.29 705.7"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="554.44 693.83 559.19 693.83 559.19 690.86 554.44 690.86 554.44 693.83"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="433.29 690.86 428.54 690.86 428.54 693.83 433.29 693.83 433.29 690.86"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="554.44"
					y1="703.33"
					x2="554.44"
					y2="705.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="554.44"
					y1="705.7"
					x2="555.63"
					y2="705.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.63"
					y1="705.7"
					x2="555.63"
					y2="703.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.63"
					y1="703.33"
					x2="554.44"
					y2="703.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="554.44"
					y1="706.89"
					x2="559.19"
					y2="706.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="559.19"
					y1="706.89"
					x2="559.19"
					y2="705.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="559.19"
					y1="705.7"
					x2="554.44"
					y2="705.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="554.44"
					y1="705.7"
					x2="554.44"
					y2="706.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="432.11"
					y1="703.33"
					x2="432.11"
					y2="705.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="432.11"
					y1="705.7"
					x2="433.29"
					y2="705.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="433.29"
					y1="705.7"
					x2="433.29"
					y2="703.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="433.29"
					y1="703.33"
					x2="432.11"
					y2="703.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="433.29"
					y1="705.7"
					x2="428.54"
					y2="705.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="428.54"
					y1="705.7"
					x2="428.54"
					y2="706.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="428.54"
					y1="706.89"
					x2="433.29"
					y2="706.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="433.29"
					y1="706.89"
					x2="433.29"
					y2="705.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="554.44"
					y1="693.83"
					x2="559.19"
					y2="693.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="559.19"
					y1="693.83"
					x2="559.19"
					y2="690.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="559.19"
					y1="690.86"
					x2="554.44"
					y2="690.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="554.44"
					y1="690.86"
					x2="554.44"
					y2="693.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="433.29"
					y1="690.86"
					x2="428.54"
					y2="690.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="428.54"
					y1="690.86"
					x2="428.54"
					y2="693.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="428.54"
					y1="693.83"
					x2="433.29"
					y2="693.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="433.29"
					y1="693.83"
					x2="433.29"
					y2="690.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="550.88 703.33 555.63 703.33 555.63 693.83 550.88 693.83 550.88 703.33"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="432.11 703.33 436.86 703.33 436.86 693.83 432.11 693.83 432.11 703.33"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="496.25 693.83 436.86 693.83 436.86 697.98 496.25 697.98 496.25 693.83"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="522.37 697.98 462.99 697.98 462.99 702.14 522.37 702.14 522.37 697.98"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="555.63"
					y1="693.83"
					x2="556.23"
					y2="693.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.63"
					y1="703.33"
					x2="556.23"
					y2="703.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="556.23"
					y1="693.83"
					x2="556.23"
					y2="703.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="432.11"
					y1="693.83"
					x2="431.52"
					y2="693.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="432.11"
					y1="703.33"
					x2="431.52"
					y2="703.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="431.52"
					y1="693.83"
					x2="431.52"
					y2="703.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="550.88"
					y1="703.33"
					x2="550.88"
					y2="693.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="550.88"
					y1="693.83"
					x2="555.63"
					y2="693.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.63"
					y1="693.83"
					x2="555.63"
					y2="703.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.63"
					y1="703.33"
					x2="550.88"
					y2="703.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="432.11"
					y1="703.33"
					x2="432.11"
					y2="693.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="432.11"
					y1="693.83"
					x2="436.86"
					y2="693.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="436.86"
					y1="693.83"
					x2="436.86"
					y2="703.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="436.86"
					y1="703.33"
					x2="432.11"
					y2="703.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="496.25"
					y1="693.83"
					x2="496.25"
					y2="697.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="496.25"
					y1="697.98"
					x2="436.86"
					y2="697.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="436.86"
					y1="697.98"
					x2="436.86"
					y2="693.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="436.86"
					y1="693.83"
					x2="496.25"
					y2="693.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="522.37"
					y1="697.98"
					x2="522.37"
					y2="702.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="522.37"
					y1="702.14"
					x2="462.99"
					y2="702.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="462.99"
					y1="702.14"
					x2="462.99"
					y2="697.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="462.99"
					y1="697.98"
					x2="522.37"
					y2="697.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="556.23"
					y1="693.83"
					x2="556.23"
					y2="703.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="556.23"
					y1="693.83"
					x2="556.23"
					y2="703.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="556.23"
					y1="703.33"
					x2="556.23"
					y2="705.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="556.23"
					y1="693.83"
					x2="559.19"
					y2="693.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="556.23"
					y1="703.33"
					x2="556.23"
					y2="705.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="556.23"
					y1="705.7"
					x2="559.19"
					y2="705.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="556.23"
					y1="705.7"
					x2="559.19"
					y2="705.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="431.52"
					y1="693.83"
					x2="431.52"
					y2="703.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="431.52"
					y1="693.83"
					x2="431.52"
					y2="703.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="431.52"
					y1="703.33"
					x2="431.52"
					y2="705.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="431.52"
					y1="693.83"
					x2="428.54"
					y2="693.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="431.52"
					y1="703.33"
					x2="431.52"
					y2="705.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="431.52"
					y1="705.7"
					x2="428.54"
					y2="705.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="431.52"
					y1="705.7"
					x2="428.54"
					y2="705.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="699.72"
					y1="112.8"
					x2="708.17"
					y2="112.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.17"
					y1="112.8"
					x2="708.17"
					y2="93.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="579.46"
					y1="93.8"
					x2="579.46"
					y2="112.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="863.85"
					y1="93.8"
					x2="863.85"
					y2="112.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="371.69 546.77 371.69 492.56 318.42 492.56 318.42 546.77 371.69 546.77"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="318.42"
					y1="546.77"
					x2="320.54"
					y2="546.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="323.96"
					y1="546.77"
					x2="329.66"
					y2="546.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="333.08"
					y1="546.77"
					x2="338.78"
					y2="546.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="342.2"
					y1="546.77"
					x2="347.9"
					y2="546.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.32"
					y1="546.77"
					x2="357.03"
					y2="546.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="360.45"
					y1="546.77"
					x2="366.15"
					y2="546.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="369.57"
					y1="546.77"
					x2="371.69"
					y2="546.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="318.42"
					y1="492.56"
					x2="318.42"
					y2="495.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="318.42"
					y1="498.57"
					x2="318.42"
					y2="504.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="318.42"
					y1="507.69"
					x2="318.42"
					y2="513.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="318.42"
					y1="516.81"
					x2="318.42"
					y2="522.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="318.42"
					y1="525.94"
					x2="318.42"
					y2="531.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="318.42"
					y1="535.06"
					x2="318.42"
					y2="540.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="318.42"
					y1="544.18"
					x2="318.42"
					y2="546.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="371.69"
					y1="492.56"
					x2="369.57"
					y2="492.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.15"
					y1="492.56"
					x2="360.45"
					y2="492.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="357.03"
					y1="492.56"
					x2="351.32"
					y2="492.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="347.9"
					y1="492.56"
					x2="342.2"
					y2="492.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="338.78"
					y1="492.56"
					x2="333.08"
					y2="492.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="329.66"
					y1="492.56"
					x2="323.96"
					y2="492.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="320.54"
					y1="492.56"
					x2="318.42"
					y2="492.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="371.69"
					y1="546.77"
					x2="371.69"
					y2="544.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="371.69"
					y1="540.76"
					x2="371.69"
					y2="535.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="371.69"
					y1="531.64"
					x2="371.69"
					y2="525.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="371.69"
					y1="522.52"
					x2="371.69"
					y2="516.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="371.69"
					y1="513.39"
					x2="371.69"
					y2="507.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="371.69"
					y1="504.27"
					x2="371.69"
					y2="498.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="371.69"
					y1="495.15"
					x2="371.69"
					y2="492.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="318.62 549.57 318.62 551.21 371.49 551.21 371.49 549.57 363.19 549.57 363.19 550.91 326.91 550.91 326.91 549.57 318.62 549.57"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="326.91"
					y1="549.57"
					x2="318.62"
					y2="549.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="326.91"
					y1="550.91"
					x2="326.91"
					y2="549.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="363.19"
					y1="550.91"
					x2="326.91"
					y2="550.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="363.19"
					y1="549.57"
					x2="363.19"
					y2="550.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="371.49"
					y1="549.57"
					x2="363.19"
					y2="549.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="371.49"
					y1="551.21"
					x2="371.49"
					y2="549.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="318.62"
					y1="551.21"
					x2="371.49"
					y2="551.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="318.62"
					y1="549.57"
					x2="318.62"
					y2="551.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<polyline
					points="316.55 549.57 373.56 549.57 373.56 546.77 316.55 546.77 316.55 549.57"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="316.55"
					y1="546.77"
					x2="316.55"
					y2="549.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="373.56"
					y1="546.77"
					x2="316.55"
					y2="546.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="373.56"
					y1="549.57"
					x2="373.56"
					y2="546.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="316.55"
					y1="549.57"
					x2="373.56"
					y2="549.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="371.49"
					y1="549.57"
					x2="371.49"
					y2="551.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="371.49"
					y1="551.21"
					x2="318.62"
					y2="551.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="318.62"
					y1="551.21"
					x2="318.62"
					y2="549.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.56"
					y1="549.57"
					x2="316.55"
					y2="549.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="326.91"
					y1="549.57"
					x2="326.91"
					y2="550.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="326.91"
					y1="550.91"
					x2="363.19"
					y2="550.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="363.19"
					y1="550.91"
					x2="363.19"
					y2="549.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.56"
					y1="546.77"
					x2="373.56"
					y2="549.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="316.55"
					y1="549.57"
					x2="316.55"
					y2="546.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="316.55"
					y1="546.77"
					x2="373.56"
					y2="546.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="147.47"
					y1="557.74"
					x2="147.47"
					y2="469.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="69.01"
					y1="557.74"
					x2="147.47"
					y2="557.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="69.01"
					y1="551.8"
					x2="147.47"
					y2="551.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="171.01 554.31 242.28 554.31 242.28 492.55 171.01 492.55 171.01 554.31"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="171.01"
					y1="554.31"
					x2="242.28"
					y2="554.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="171.01"
					y1="492.55"
					x2="242.28"
					y2="492.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="171.01"
					y1="494.42"
					x2="242.28"
					y2="494.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="171.01"
					y1="554.31"
					x2="171.01"
					y2="492.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="242.28"
					y1="554.31"
					x2="242.28"
					y2="492.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="175.69"
					y1="551.5"
					x2="237.6"
					y2="551.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="237.6"
					y1="551.5"
					x2="239.47"
					y2="549.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="239.47"
					y1="549.63"
					x2="239.47"
					y2="497.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="239.47"
					y1="497.22"
					x2="237.6"
					y2="495.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="237.6"
					y1="495.35"
					x2="175.69"
					y2="495.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="175.69"
					y1="495.35"
					x2="173.82"
					y2="497.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="173.82"
					y1="497.22"
					x2="173.82"
					y2="549.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="173.82"
					y1="549.63"
					x2="175.69"
					y2="551.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m198.18,538.87c0-5.17-4.19-9.35-9.35-9.35s-9.35,4.19-9.35,9.35,4.19,9.35,9.35,9.35,9.35-4.19,9.35-9.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m195.84,507.99c0-3.87-3.14-7.01-7.01-7.01s-7.01,3.14-7.01,7.01,3.14,7.01,7.01,7.01,7.01-3.14,7.01-7.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m231.48,538.87c0-3.87-3.14-7.01-7.01-7.01s-7.01,3.14-7.01,7.01,3.14,7.01,7.01,7.01,7.01-3.14,7.01-7.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m233.81,507.99c0-5.16-4.19-9.35-9.35-9.35s-9.35,4.19-9.35,9.35,4.19,9.35,9.35,9.35,9.35-4.19,9.35-9.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="251.45 544.81 302.68 544.81 303.62 544.55 304.3 543.87 304.55 542.94 304.55 494.42 304.3 493.48 303.62 492.8 302.68 492.55 251.45 492.55 250.52 492.8 249.83 493.48 249.58 494.42 249.58 542.94 249.83 543.87 250.52 544.55 251.45 544.81"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m251.45,544.81c-1.03,0-1.87-.84-1.87-1.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="249.58"
					y1="494.42"
					x2="249.58"
					y2="542.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m249.58,494.42c0-1.03.84-1.87,1.87-1.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="302.68"
					y1="492.55"
					x2="251.45"
					y2="492.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m302.68,492.55c1.03,0,1.87.84,1.87,1.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="304.55"
					y1="542.94"
					x2="304.55"
					y2="494.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m304.55,542.94c0,1.03-.84,1.87-1.87,1.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="251.45"
					y1="544.81"
					x2="302.68"
					y2="544.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.13"
					y1="540.13"
					x2="298.01"
					y2="540.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="299.88"
					y1="538.26"
					x2="299.88"
					y2="503.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="298.01"
					y1="501.9"
					x2="256.13"
					y2="501.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="254.26"
					y1="503.77"
					x2="254.26"
					y2="538.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.13"
					y1="540.13"
					x2="256.13"
					y2="540.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m299.88,538.26c0,1.03-.83,1.87-1.87,1.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m298.01,501.9c1.03,0,1.87.83,1.87,1.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m254.26,503.77c0-1.03.84-1.87,1.87-1.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m256.13,540.13c-1.03,0-1.87-.83-1.87-1.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m279.87,511.25c0-1.55-1.26-2.81-2.81-2.81s-2.81,1.26-2.81,2.81,1.26,2.8,2.81,2.8,2.81-1.25,2.81-2.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="276.23 513.86 276.47 514.46 277.07 514.7 277.66 514.45 277.91 513.86 277.91 495.35 277.66 494.76 277.07 494.51 276.47 494.76 276.23 495.35 276.23 513.86"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="276.23"
					y1="495.35"
					x2="276.23"
					y2="513.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m276.23,495.35c0-.47.38-.84.84-.84s.84.38.84.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.91"
					y1="513.86"
					x2="277.91"
					y2="495.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m277.91,513.86h0c0,.47-.38.84-.84.84s-.84-.38-.84-.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="275.2 500.12 276.23 500.12 276.23 495.35 276.47 494.76 277.07 494.51 277.66 494.76 277.91 495.35 277.91 500.12 278.94 500.12 278.94 494.04 275.2 494.04 275.2 500.12"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="275.2"
					y1="494.04"
					x2="275.2"
					y2="500.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="278.94"
					y1="494.04"
					x2="275.2"
					y2="494.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="278.94"
					y1="500.12"
					x2="278.94"
					y2="494.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.91"
					y1="500.12"
					x2="278.94"
					y2="500.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.91"
					y1="495.35"
					x2="277.91"
					y2="500.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m276.23,495.35c0-.47.38-.84.84-.84s.84.38.84.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="276.23"
					y1="500.12"
					x2="276.23"
					y2="495.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="275.2"
					y1="500.12"
					x2="276.23"
					y2="500.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="275.23 503.49 276.23 503.49 276.23 500.21 275.23 500.21 275.23 503.49"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="275.23"
					y1="500.21"
					x2="275.23"
					y2="503.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="276.23"
					y1="500.21"
					x2="275.23"
					y2="500.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="276.23"
					y1="503.49"
					x2="276.23"
					y2="500.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="275.23"
					y1="503.49"
					x2="276.23"
					y2="503.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="278.91 503.49 278.91 500.21 277.91 500.21 277.91 503.49 278.91 503.49"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="277.91"
					y1="503.49"
					x2="278.91"
					y2="503.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.91"
					y1="500.21"
					x2="277.91"
					y2="503.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="278.91"
					y1="500.21"
					x2="277.91"
					y2="500.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="278.91"
					y1="503.49"
					x2="278.91"
					y2="500.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="832.8 572.09 830.91 576.33 830.25 580.93 830.91 585.52 832.8 589.76 835.2 592.55 838.21 594.67 841.66 596.24 845.28 597.36 851.15 598.31 857.09 597.96 862.8 596.32 868.03 596.45 873.09 597.77 877.71 600.22 879.72 601.5 883.85 603 888.23 602.77 889.97 602.09 894.58 602.09 894.58 600.17 892.48 600.17 894.42 596.95 895.18 593.27 895.18 568.59 894.43 564.94 892.42 561.82 889.4 559.64 885.81 558.7 885.24 558.7 882.27 559.19 877.6 561.69 873.03 564.12 868.03 565.43 862.86 565.56 857.13 563.9 851.17 563.54 845.28 564.49 841.66 565.61 838.21 567.18 835.2 569.3 832.8 572.09"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="873.24"
					y1="589.72"
					x2="873.24"
					y2="572.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="895.18"
					y1="568.59"
					x2="895.18"
					y2="580.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="894.29"
					y1="568.59"
					x2="894.29"
					y2="580.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="895.18"
					y1="593.27"
					x2="895.18"
					y2="580.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="894.29"
					y1="593.27"
					x2="894.29"
					y2="580.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="873.24"
					y1="572.59"
					x2="876.53"
					y2="572.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="876.53"
					y1="572.59"
					x2="876.53"
					y2="575.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="876.53"
					y1="575.31"
					x2="873.24"
					y2="575.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="873.24"
					y1="589.26"
					x2="876.53"
					y2="589.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="876.53"
					y1="589.26"
					x2="876.53"
					y2="586.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="876.53"
					y1="586.55"
					x2="873.24"
					y2="586.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="886.41"
					y1="600.17"
					x2="894.58"
					y2="600.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="886.41"
					y1="602.09"
					x2="894.58"
					y2="602.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="894.58"
					y1="602.09"
					x2="894.58"
					y2="600.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="886.41"
					y1="602.09"
					x2="886.41"
					y2="600.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="830.25"
					y1="580.93"
					x2="830.59"
					y2="577.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="830.59"
					y1="577.98"
					x2="831.35"
					y2="575.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="831.35"
					y1="575.13"
					x2="832.8"
					y2="572.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="832.8"
					y1="572.09"
					x2="835.19"
					y2="569.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="835.19"
					y1="569.29"
					x2="838.21"
					y2="567.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="838.21"
					y1="567.18"
					x2="841.64"
					y2="565.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="841.64"
					y1="565.62"
					x2="845.28"
					y2="564.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="845.28"
					y1="564.49"
					x2="851.16"
					y2="563.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="851.16"
					y1="563.46"
					x2="854.13"
					y2="563.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="854.13"
					y1="563.41"
					x2="857.08"
					y2="563.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="857.08"
					y1="563.74"
					x2="861.67"
					y2="565.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="861.67"
					y1="565.08"
					x2="866.11"
					y2="567.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="866.11"
					y1="567.16"
					x2="870.07"
					y2="569.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="870.07"
					y1="569.63"
					x2="873.24"
					y2="572.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="862.86"
					y1="565.56"
					x2="866.98"
					y2="565.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="866.98"
					y1="565.54"
					x2="870.98"
					y2="564.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="870.98"
					y1="564.86"
					x2="873.14"
					y2="564.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="873.14"
					y1="564.16"
					x2="875.28"
					y2="563.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="875.28"
					y1="563.16"
					x2="878.39"
					y2="561.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="878.39"
					y1="561.17"
					x2="881.61"
					y2="559.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="881.61"
					y1="559.42"
					x2="884.75"
					y2="558.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="884.75"
					y1="558.72"
					x2="887.89"
					y2="558.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="887.89"
					y1="558.99"
					x2="890.74"
					y2="560.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="890.74"
					y1="560.21"
					x2="891.97"
					y2="561.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="891.97"
					y1="561.17"
					x2="893.03"
					y2="562.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="893.03"
					y1="562.36"
					x2="894.2"
					y2="564.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="894.2"
					y1="564.47"
					x2="894.84"
					y2="566.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="894.84"
					y1="566.48"
					x2="895.18"
					y2="568.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="894.29"
					y1="568.59"
					x2="894.2"
					y2="567.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="894.2"
					y1="567.64"
					x2="893.6"
					y2="565.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="893.6"
					y1="565.71"
					x2="892.15"
					y2="563.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="892.15"
					y1="563.99"
					x2="890.14"
					y2="562.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="890.14"
					y1="562.92"
					x2="887.49"
					y2="562.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="887.49"
					y1="562.41"
					x2="884.76"
					y2="562.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="884.76"
					y1="562.29"
					x2="883.4"
					y2="562.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="883.4"
					y1="562.31"
					x2="882.33"
					y2="562.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="882.33"
					y1="562.88"
					x2="882.02"
					y2="563.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="882.02"
					y1="563.55"
					x2="879.9"
					y2="571.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="879.9"
					y1="571.01"
					x2="879.27"
					y2="574.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="879.27"
					y1="574.72"
					x2="878.99"
					y2="578.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="878.99"
					y1="578.47"
					x2="878.99"
					y2="580.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="862.8"
					y1="596.32"
					x2="866.93"
					y2="596.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="866.93"
					y1="596.34"
					x2="870.96"
					y2="597.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="870.96"
					y1="597.02"
					x2="873.13"
					y2="597.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="873.13"
					y1="597.7"
					x2="875.28"
					y2="598.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="875.28"
					y1="598.69"
					x2="878.4"
					y2="600.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="878.4"
					y1="600.67"
					x2="881.61"
					y2="602.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="881.61"
					y1="602.43"
					x2="883.71"
					y2="603.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="883.71"
					y1="603.01"
					x2="885.87"
					y2="603.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="885.87"
					y1="603.14"
					x2="887.99"
					y2="602.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="887.99"
					y1="602.84"
					x2="889.97"
					y2="602.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="894.29"
					y1="593.27"
					x2="894.2"
					y2="594.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="894.2"
					y1="594.21"
					x2="893.6"
					y2="596.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="893.6"
					y1="596.14"
					x2="892.15"
					y2="597.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="892.15"
					y1="597.86"
					x2="890.14"
					y2="598.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="890.14"
					y1="598.94"
					x2="887.49"
					y2="599.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="887.49"
					y1="599.45"
					x2="884.76"
					y2="599.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="884.76"
					y1="599.56"
					x2="883.4"
					y2="599.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="883.4"
					y1="599.55"
					x2="882.33"
					y2="598.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="882.33"
					y1="598.97"
					x2="882.02"
					y2="598.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="882.02"
					y1="598.31"
					x2="879.9"
					y2="590.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="879.9"
					y1="590.84"
					x2="879.27"
					y2="587.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="879.27"
					y1="587.13"
					x2="878.99"
					y2="583.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="878.99"
					y1="583.38"
					x2="878.99"
					y2="580.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="830.25"
					y1="580.93"
					x2="830.59"
					y2="583.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="830.59"
					y1="583.87"
					x2="831.35"
					y2="586.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="831.35"
					y1="586.73"
					x2="832.8"
					y2="589.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="832.8"
					y1="589.76"
					x2="835.19"
					y2="592.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="835.19"
					y1="592.56"
					x2="838.21"
					y2="594.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="838.21"
					y1="594.67"
					x2="841.64"
					y2="596.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="841.64"
					y1="596.23"
					x2="845.28"
					y2="597.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="845.28"
					y1="597.36"
					x2="851.16"
					y2="598.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="851.16"
					y1="598.39"
					x2="854.13"
					y2="598.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="854.13"
					y1="598.44"
					x2="857.08"
					y2="598.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="857.08"
					y1="598.11"
					x2="861.67"
					y2="596.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="861.67"
					y1="596.78"
					x2="866.11"
					y2="594.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="866.11"
					y1="594.7"
					x2="870.07"
					y2="592.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="870.07"
					y1="592.22"
					x2="873.24"
					y2="589.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="879.9"
					y1="560.25"
					x2="879.23"
					y2="560.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="879.23"
					y1="560.72"
					x2="878.23"
					y2="562.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="878.23"
					y1="562.08"
					x2="877.99"
					y2="563.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="877.99"
					y1="563.26"
					x2="877.34"
					y2="570.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="877.34"
					y1="570.84"
					x2="877.05"
					y2="578.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="877.05"
					y1="578.44"
					x2="877.05"
					y2="580.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="879.9"
					y1="601.6"
					x2="879.23"
					y2="601.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="879.23"
					y1="601.13"
					x2="878.23"
					y2="599.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="878.23"
					y1="599.77"
					x2="877.99"
					y2="598.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="877.99"
					y1="598.59"
					x2="877.34"
					y2="591.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="877.34"
					y1="591.01"
					x2="877.05"
					y2="583.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="877.05"
					y1="583.42"
					x2="877.05"
					y2="580.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="892.48"
					y1="600.17"
					x2="893.03"
					y2="599.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="893.03"
					y1="599.49"
					x2="894.2"
					y2="597.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="894.2"
					y1="597.38"
					x2="894.84"
					y2="595.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="894.84"
					y1="595.37"
					x2="895.18"
					y2="593.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="848.09 617.3 848.09 687.92 895.18 687.92 895.18 617.3 848.09 617.3"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="848.09"
					y1="617.3"
					x2="848.09"
					y2="687.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="895.18"
					y1="617.3"
					x2="895.18"
					y2="687.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="848.09"
					y1="687.92"
					x2="895.18"
					y2="687.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="848.09"
					y1="617.3"
					x2="895.18"
					y2="617.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="893.31"
					y1="617.3"
					x2="893.31"
					y2="687.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="859.16"
					y1="628.85"
					x2="859.16"
					y2="676.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="859.16"
					y1="676.36"
					x2="887.67"
					y2="676.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="887.67"
					y1="676.36"
					x2="887.67"
					y2="628.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="887.67"
					y1="628.85"
					x2="859.16"
					y2="628.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="857.29"
					y1="626.99"
					x2="857.29"
					y2="678.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="857.29"
					y1="678.23"
					x2="889.54"
					y2="678.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="889.54"
					y1="678.23"
					x2="889.54"
					y2="626.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="889.54"
					y1="626.99"
					x2="857.29"
					y2="626.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m884.04,652.61c0-1.55-1.26-2.8-2.8-2.8s-2.81,1.26-2.81,2.8,1.26,2.81,2.81,2.81,2.8-1.26,2.8-2.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="892.78 650.27 888.86 650.64 887.97 650.95 883.02 651.57 882.36 651.92 882.1 652.61 882.36 653.3 883.02 653.65 887.97 654.27 888.86 654.57 892.78 654.95 894.16 654.5 895.01 653.33 895.01 651.89 894.16 650.72 892.78 650.27"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m892.78,650.27c1.29,0,2.34,1.05,2.34,2.34s-1.05,2.34-2.34,2.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="888.86"
					y1="654.57"
					x2="892.78"
					y2="654.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m888.86,654.57c-.32-.03-.62-.14-.89-.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="883.02"
					y1="653.65"
					x2="887.97"
					y2="654.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m883.02,653.65c-.52-.07-.92-.51-.92-1.04s.39-.97.92-1.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="887.97"
					y1="650.95"
					x2="883.02"
					y2="651.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m887.97,650.95c.27-.17.57-.28.89-.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="892.78"
					y1="650.27"
					x2="888.86"
					y2="650.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="890.45"
					y1="653.88"
					x2="889.06"
					y2="653.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="889.06"
					y1="651.34"
					x2="890.45"
					y2="651.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="890.45"
					y1="651.34"
					x2="890.45"
					y2="653.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m889.06,653.88c-.7,0-1.27-.57-1.27-1.27s.57-1.27,1.27-1.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m887.97,654.27c-.56-.36-.9-.99-.9-1.66s.34-1.29.9-1.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="895.18 552.42 894.23 552.42 894.23 557.17 895.18 557.17 895.18 552.42"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="895.18"
					y1="557.17"
					x2="895.18"
					y2="552.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="894.23"
					y1="557.17"
					x2="895.18"
					y2="557.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="894.23"
					y1="552.42"
					x2="894.23"
					y2="557.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="895.18"
					y1="552.42"
					x2="894.23"
					y2="552.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="895.18 609.43 895.18 604.68 894.23 604.68 894.23 609.43 895.18 609.43"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="894.23"
					y1="609.43"
					x2="895.18"
					y2="609.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="894.23"
					y1="604.68"
					x2="894.23"
					y2="609.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="895.18"
					y1="604.68"
					x2="894.23"
					y2="604.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="895.18"
					y1="609.43"
					x2="895.18"
					y2="604.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="894.23 554.32 886.5 554.32 886.5 555.27 894.23 555.27 894.23 554.32"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="894.23"
					y1="555.27"
					x2="894.23"
					y2="554.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="886.5"
					y1="555.27"
					x2="894.23"
					y2="555.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="886.5"
					y1="554.32"
					x2="886.5"
					y2="555.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="894.23"
					y1="554.32"
					x2="886.5"
					y2="554.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="894.23 607.53 894.23 606.58 886.5 606.58 886.5 607.53 894.23 607.53"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="886.5"
					y1="607.53"
					x2="894.23"
					y2="607.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="886.5"
					y1="606.58"
					x2="886.5"
					y2="607.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="894.23"
					y1="606.58"
					x2="886.5"
					y2="606.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="894.23"
					y1="607.53"
					x2="894.23"
					y2="606.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="888.87 555.27 886.97 555.27 886.97 606.58 888.87 606.58 888.87 555.27"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="888.87"
					y1="606.58"
					x2="888.87"
					y2="555.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="886.97"
					y1="606.58"
					x2="888.87"
					y2="606.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="886.97"
					y1="555.27"
					x2="886.97"
					y2="606.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="888.87"
					y1="555.27"
					x2="886.97"
					y2="555.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="876.76 762.58 876.76 687.92 736.93 687.92 736.93 762.58 876.76 762.58"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="736.93"
					y1="762.58"
					x2="876.76"
					y2="762.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.93"
					y1="687.92"
					x2="736.93"
					y2="762.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="876.76"
					y1="687.92"
					x2="736.93"
					y2="687.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="876.76"
					y1="762.58"
					x2="876.76"
					y2="687.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="868 753.74 868 697.75 746.29 697.75 746.29 753.74 868 753.74"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="746.29"
					y1="753.74"
					x2="868"
					y2="753.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="746.29"
					y1="697.75"
					x2="746.29"
					y2="753.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="868"
					y1="697.75"
					x2="746.29"
					y2="697.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="868"
					y1="753.74"
					x2="868"
					y2="697.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="856.04 725.25 856.08 725.75 856.2 726.24 856.4 726.7 856.67 727.12 857 727.47 857.38 727.76 857.8 727.97 858.25 728.1 858.71 728.15 859.17 728.1 859.62 727.97 860.04 727.76 860.43 727.47 860.76 727.12 861.02 726.7 861.22 726.24 861.34 725.75 861.38 725.25 861.34 724.75 861.22 724.26 861.02 723.8 860.76 723.39 860.43 723.03 860.04 722.75 859.62 722.53 859.17 722.4 858.71 722.36 858.25 722.4 857.8 722.53 857.38 722.75 857 723.03 856.67 723.39 856.4 723.8 856.2 724.26 856.08 724.75 856.04 725.25"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="856.08"
					y1="724.75"
					x2="856.04"
					y2="725.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="856.2"
					y1="724.26"
					x2="856.08"
					y2="724.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="856.4"
					y1="723.8"
					x2="856.2"
					y2="724.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="856.67"
					y1="723.39"
					x2="856.4"
					y2="723.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="857"
					y1="723.03"
					x2="856.67"
					y2="723.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="857.38"
					y1="722.75"
					x2="857"
					y2="723.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="857.8"
					y1="722.53"
					x2="857.38"
					y2="722.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="858.25"
					y1="722.4"
					x2="857.8"
					y2="722.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="858.71"
					y1="722.36"
					x2="858.25"
					y2="722.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="859.17"
					y1="722.4"
					x2="858.71"
					y2="722.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="859.62"
					y1="722.53"
					x2="859.17"
					y2="722.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="860.04"
					y1="722.75"
					x2="859.62"
					y2="722.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="860.43"
					y1="723.03"
					x2="860.04"
					y2="722.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="860.76"
					y1="723.39"
					x2="860.43"
					y2="723.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="861.02"
					y1="723.8"
					x2="860.76"
					y2="723.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="861.22"
					y1="724.26"
					x2="861.02"
					y2="723.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="861.34"
					y1="724.75"
					x2="861.22"
					y2="724.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="861.38"
					y1="725.25"
					x2="861.34"
					y2="724.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="861.34"
					y1="725.75"
					x2="861.38"
					y2="725.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="861.22"
					y1="726.24"
					x2="861.34"
					y2="725.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="861.02"
					y1="726.7"
					x2="861.22"
					y2="726.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="860.76"
					y1="727.12"
					x2="861.02"
					y2="726.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="860.43"
					y1="727.47"
					x2="860.76"
					y2="727.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="860.04"
					y1="727.76"
					x2="860.43"
					y2="727.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="859.62"
					y1="727.97"
					x2="860.04"
					y2="727.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="859.17"
					y1="728.1"
					x2="859.62"
					y2="727.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="858.71"
					y1="728.15"
					x2="859.17"
					y2="728.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="858.25"
					y1="728.1"
					x2="858.71"
					y2="728.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="857.8"
					y1="727.97"
					x2="858.25"
					y2="728.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="857.38"
					y1="727.76"
					x2="857.8"
					y2="727.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="857"
					y1="727.47"
					x2="857.38"
					y2="727.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="856.67"
					y1="727.12"
					x2="857"
					y2="727.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="856.4"
					y1="726.7"
					x2="856.67"
					y2="727.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="856.2"
					y1="726.24"
					x2="856.4"
					y2="726.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="856.08"
					y1="725.75"
					x2="856.2"
					y2="726.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="856.04"
					y1="725.25"
					x2="856.08"
					y2="725.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="871.13 722.75 871.53 722.79 871.91 722.91 872.28 723.09 872.61 723.34 872.89 723.65 873.12 724 873.29 724.4 873.4 724.82 873.43 725.25 873.4 725.69 873.29 726.11 873.12 726.5 872.89 726.86 872.61 727.17 872.28 727.41 871.91 727.6 871.53 727.71 871.13 727.75 867.26 727.35 866.95 727.3 866.66 727.18 866.38 727.02 861.51 726.36 861.33 726.32 861.17 726.25 861.02 726.15 860.89 726.03 860.78 725.88 860.69 725.71 860.63 725.54 860.61 725.35 860.61 725.16 860.63 724.97 860.7 724.79 860.78 724.63 860.89 724.48 861.02 724.35 861.17 724.25 861.33 724.18 861.51 724.14 866.38 723.48 866.66 723.32 866.95 723.21 867.26 723.15 871.13 722.75"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="871.13"
					y1="722.75"
					x2="867.26"
					y2="723.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="866.38"
					y1="723.48"
					x2="861.51"
					y2="724.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="861.51"
					y1="726.36"
					x2="866.38"
					y2="727.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="867.26"
					y1="727.35"
					x2="871.13"
					y2="727.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="868.83"
					y1="726.61"
					x2="867.46"
					y2="726.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="867.46"
					y1="723.89"
					x2="868.83"
					y2="723.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="868.83"
					y1="723.89"
					x2="868.83"
					y2="726.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m866.38,723.48c.26-.18.57-.3.88-.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m861.51,726.36c-.52-.07-.9-.54-.9-1.11s.39-1.04.9-1.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m867.26,727.35c-.31-.03-.61-.14-.88-.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m871.13,722.75c1.27,0,2.3,1.12,2.3,2.5s-1.03,2.5-2.3,2.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m867.46,726.61c-.69,0-1.25-.61-1.25-1.36s.56-1.36,1.25-1.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m866.38,727.02c-.55-.39-.89-1.05-.89-1.77s.34-1.38.89-1.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.3"
					y1="710.31"
					x2="671.3"
					y2="693.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.3"
					y1="693.69"
					x2="626.16"
					y2="693.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="680.8"
					y1="710.31"
					x2="616.66"
					y2="710.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="680.8"
					y1="753.07"
					x2="680.8"
					y2="688.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="680.8"
					y1="690.12"
					x2="616.66"
					y2="690.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="626.16"
					y1="710.31"
					x2="626.16"
					y2="693.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="680.8"
					y1="688.93"
					x2="616.66"
					y2="688.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="145.09"
					y1="557.74"
					x2="145.09"
					y2="562.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="145.09"
					y1="562.43"
					x2="142.72"
					y2="562.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="142.72"
					y1="562.43"
					x2="142.72"
					y2="557.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="69.01"
					y1="549.56"
					x2="74.6"
					y2="549.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="78.02"
					y1="549.56"
					x2="83.72"
					y2="549.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="87.14"
					y1="549.56"
					x2="92.85"
					y2="549.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="96.27"
					y1="549.56"
					x2="101.97"
					y2="549.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="105.39"
					y1="549.56"
					x2="111.09"
					y2="549.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="114.51"
					y1="549.56"
					x2="120.21"
					y2="549.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="123.63"
					y1="549.56"
					x2="129.33"
					y2="549.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="132.75"
					y1="549.56"
					x2="138.45"
					y2="549.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="141.87"
					y1="549.56"
					x2="147.47"
					y2="549.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="147.47"
					y1="521.05"
					x2="150.81"
					y2="521.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="154.23"
					y1="521.05"
					x2="159.93"
					y2="521.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="163.35"
					y1="521.05"
					x2="169.05"
					y2="521.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="172.47"
					y1="521.05"
					x2="178.17"
					y2="521.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="181.59"
					y1="521.05"
					x2="187.3"
					y2="521.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="190.72"
					y1="521.05"
					x2="196.42"
					y2="521.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="199.84"
					y1="521.05"
					x2="205.54"
					y2="521.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.96"
					y1="521.05"
					x2="214.66"
					y2="521.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="218.08"
					y1="521.05"
					x2="223.78"
					y2="521.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="227.2"
					y1="521.05"
					x2="232.9"
					y2="521.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="236.32"
					y1="521.05"
					x2="242.03"
					y2="521.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="245.45"
					y1="521.05"
					x2="251.15"
					y2="521.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="254.57"
					y1="521.05"
					x2="260.27"
					y2="521.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="263.69"
					y1="521.05"
					x2="269.39"
					y2="521.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="272.81"
					y1="521.05"
					x2="278.51"
					y2="521.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="281.93"
					y1="521.05"
					x2="287.63"
					y2="521.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.05"
					y1="521.05"
					x2="296.76"
					y2="521.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="300.18"
					y1="521.05"
					x2="305.88"
					y2="521.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="309.3"
					y1="521.05"
					x2="315"
					y2="521.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="318.42"
					y1="521.05"
					x2="324.12"
					y2="521.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="327.54"
					y1="521.05"
					x2="333.24"
					y2="521.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="336.67"
					y1="521.05"
					x2="342.36"
					y2="521.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.78"
					y1="521.05"
					x2="351.49"
					y2="521.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.91"
					y1="521.05"
					x2="360.61"
					y2="521.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="364.03"
					y1="521.05"
					x2="369.73"
					y2="521.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.15"
					y1="521.05"
					x2="376.49"
					y2="521.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="147.47"
					y1="549.56"
					x2="171.01"
					y2="549.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="376.49"
					y1="549.56"
					x2="376.49"
					y2="492.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="242.28"
					y1="549.56"
					x2="376.49"
					y2="549.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="437.2"
					y1="93.8"
					x2="579.46"
					y2="93.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="579.46"
					y1="112.8"
					x2="437.2"
					y2="112.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.17"
					y1="93.8"
					x2="863.85"
					y2="93.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="863.85"
					y1="112.8"
					x2="708.17"
					y2="112.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.3"
					y1="745.95"
					x2="626.16"
					y2="745.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="626.16"
					y1="745.95"
					x2="626.16"
					y2="715.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="626.16"
					y1="715.06"
					x2="671.3"
					y2="715.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.3"
					y1="715.06"
					x2="671.3"
					y2="745.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
			</g>
			<g id="walls">
				<polygon
					points="506.42 528.68 506.42 540.57 450.42 540.57 450.42 492.54 147.46 492.54 147.46 469.17 69.01 469.17 69.01 675.07 194.9 675.07 194.9 886.01 239.52 886.01 239.52 905.02 175.9 905.02 175.9 740.63 50 740.63 50 450.17 378.98 450.17 378.98 93.8 437.21 93.8 437.21 112.8 397.99 112.8 397.99 464.04 462.3 464.04 462.3 528.68 506.42 528.68"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.08"
				/>
				<polygon
					points="708.17 93.8 708.17 112.8 699.71 112.8 699.71 190.08 647.5 190.08 647.5 408.82 606.39 408.82 606.39 528.68 617.21 528.68 617.21 540.57 582.43 540.57 582.43 528.68 594.51 528.68 594.51 396.93 635.63 396.93 635.63 231.59 604.82 231.59 604.82 112.8 579.46 112.8 579.46 93.8 708.17 93.8"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.08"
				/>
				<polygon
					points="950 128.04 950 171.88 940.14 171.88 940.14 781.59 354.73 781.59 354.73 905.02 329.79 905.02 329.79 886.01 335.73 886.01 335.73 762.58 401.02 762.58 401.02 693.83 431.52 693.83 431.52 705.7 412.9 705.7 412.9 762.58 564.43 762.58 564.43 705.7 556.23 705.7 556.23 693.83 564.43 693.83 564.43 671.26 617.77 671.26 617.77 683.13 613.36 683.13 613.36 762.58 683.76 762.58 683.76 683.13 679.54 683.13 679.54 671.26 725.05 671.26 725.05 628.74 736.93 628.74 736.93 762.58 876.76 762.58 876.76 687.93 895.18 687.93 895.18 540.57 736.93 540.57 736.93 552.73 725.05 552.73 725.05 540.57 693.23 540.57 693.23 528.68 921.14 528.68 921.14 152.87 930.99 152.87 930.99 128.04 930.48 124.09 928.96 120.42 926.53 117.26 923.38 114.84 919.7 113.32 915.76 112.8 863.85 112.8 863.85 93.8 915.76 93.8 921.71 94.31 927.47 95.87 932.88 98.39 937.77 101.8 941.98 106.03 945.41 110.92 947.93 116.33 949.47 122.09 950 128.04"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.08"
				/>
			</g>
			<g id="text">
				<path d="m333.42,538.6v-11.02h3.79c.86,0,1.51.05,1.96.16.63.15,1.17.41,1.62.79.58.49,1.01,1.12,1.3,1.89.29.76.44,1.63.44,2.62,0,.84-.1,1.58-.29,2.22-.2.65-.45,1.18-.75,1.61-.31.42-.64.75-1.01,1-.36.24-.8.42-1.32.55-.51.13-1.1.19-1.77.19h-3.98Zm1.46-1.3h2.35c.73,0,1.3-.07,1.71-.2.42-.14.75-.33.99-.57.35-.35.61-.81.8-1.39.2-.59.29-1.3.29-2.13,0-1.15-.19-2.04-.57-2.65-.38-.62-.83-1.04-1.38-1.25-.39-.15-1.02-.23-1.89-.23h-2.31v8.42Zm11.58,1.3l-2.92-11.02h1.5l1.68,7.22c.18.76.34,1.51.47,2.25.28-1.18.45-1.86.5-2.04l2.1-7.44h1.76l1.58,5.58c.4,1.38.68,2.68.86,3.9.14-.7.32-1.5.55-2.4l1.73-7.08h1.47l-3.02,11.02h-1.41l-2.32-8.39c-.2-.7-.31-1.13-.35-1.29-.12.51-.22.94-.32,1.29l-2.34,8.39h-1.49Z" />
				<path d="m104.76,520.06h-1.55l-1.86-3.11c-.17-.29-.34-.53-.5-.73-.16-.21-.32-.37-.5-.5-.17-.13-.35-.22-.54-.28-.19-.06-.41-.09-.65-.09h-1.07v4.72h-1.3v-11.09h3.31c.48,0,.93.06,1.34.19.41.12.77.3,1.07.55.3.25.54.56.71.93.17.37.26.8.26,1.29,0,.39-.06.74-.18,1.07-.11.32-.28.61-.5.86-.21.25-.47.47-.77.65-.3.18-.64.31-1.01.41v.03c.19.08.35.18.48.29.14.1.27.23.39.37.12.14.24.31.36.5.12.18.26.39.41.63l2.08,3.33Zm-6.65-9.92v4.02h1.76c.32,0,.62-.05.9-.15.28-.1.52-.24.72-.42.2-.19.36-.41.47-.67.11-.27.17-.57.17-.9,0-.59-.19-1.05-.58-1.38-.38-.34-.94-.5-1.66-.5h-1.78Zm14.23,6.27h-5.59c.02.88.26,1.56.71,2.04.45.48,1.08.72,1.87.72.89,0,1.71-.29,2.46-.88v1.19c-.7.51-1.62.76-2.76.76s-2-.36-2.64-1.08c-.64-.72-.96-1.74-.96-3.04,0-1.23.35-2.24,1.04-3.01.7-.78,1.57-1.17,2.61-1.17s1.84.34,2.41,1.01c.57.67.85,1.6.85,2.79v.67Zm-1.3-1.08c0-.73-.18-1.3-.53-1.71-.35-.41-.83-.61-1.45-.61s-1.11.21-1.52.64c-.42.43-.68.99-.77,1.68h4.28Zm6.99-5.89c-.25-.14-.53-.21-.84-.21-.89,0-1.33.56-1.33,1.68v1.22h1.86v1.08h-1.86v6.84h-1.26v-6.84h-1.35v-1.08h1.35v-1.28c0-.83.24-1.49.72-1.96.48-.48,1.08-.73,1.79-.73.39,0,.69.05.92.14v1.14Z" />
				<path d="m119.36,520.23c-.24,0-.44-.09-.61-.26-.17-.17-.25-.37-.25-.61s.08-.44.25-.61c.17-.18.37-.26.61-.26s.45.09.62.26c.17.17.26.37.26.61s-.09.44-.26.61c-.17.17-.38.26-.62.26Z" />
				<path d="m770.72,653.56v-17.22h4.9c1.49,0,2.67.36,3.54,1.09.87.73,1.31,1.68,1.31,2.85,0,.98-.26,1.82-.79,2.55-.53.72-1.26,1.23-2.18,1.54v.05c1.16.14,2.09.58,2.79,1.32.7.74,1.04,1.7,1.04,2.88,0,1.47-.53,2.67-1.58,3.58-1.06.91-2.39,1.37-4,1.37h-5.02Zm2.02-15.39v5.56h2.06c1.1,0,1.97-.26,2.61-.79.63-.54.95-1.29.95-2.26,0-1.67-1.1-2.51-3.3-2.51h-2.32Zm0,7.37v6.19h2.74c1.18,0,2.1-.28,2.75-.84.66-.56.98-1.33.98-2.3,0-2.03-1.38-3.05-4.15-3.05h-2.32Zm20.61,8.02h-1.97v-1.92h-.05c-.86,1.47-2.12,2.21-3.78,2.21-1.22,0-2.18-.32-2.88-.97-.69-.65-1.03-1.51-1.03-2.58,0-2.3,1.35-3.63,4.06-4.01l3.69-.52c0-2.09-.84-3.13-2.53-3.13-1.48,0-2.82.5-4.01,1.51v-2.02c1.21-.77,2.6-1.15,4.18-1.15,2.89,0,4.33,1.53,4.33,4.59v8Zm-1.97-6.22l-2.97.41c-.91.13-1.6.36-2.06.68-.46.32-.7.89-.7,1.72,0,.6.21,1.09.64,1.48.43.38,1,.56,1.72.56.98,0,1.78-.34,2.41-1.02.64-.69.96-1.56.96-2.61v-1.22Zm11.39,6.1c-.46.26-1.08.38-1.84.38-2.15,0-3.23-1.2-3.23-3.6v-7.28h-2.11v-1.68h2.11v-3l1.97-.64v3.64h3.1v1.68h-3.1v6.93c0,.82.14,1.41.42,1.76.28.35.74.53,1.39.53.5,0,.92-.14,1.28-.41v1.68Zm12.84.12h-1.97v-7.08c0-2.56-.95-3.84-2.86-3.84-.96,0-1.77.37-2.43,1.12-.66.74-.98,1.68-.98,2.85v6.96h-1.97v-18.2h1.97v7.95h.05c.94-1.55,2.29-2.33,4.03-2.33,2.77,0,4.15,1.67,4.15,5.01v7.58Z" />
				<path d="m461.38,299h-8.93v-17.22h2.02v15.39h6.91v1.82Zm3.33-15.41c-.35,0-.65-.12-.9-.36-.25-.24-.37-.54-.37-.91s.12-.67.37-.91c.25-.25.55-.37.9-.37s.66.12.91.37c.26.24.38.54.38.91s-.13.65-.38.9c-.25.25-.55.37-.91.37Zm.96,15.41h-1.97v-12.29h1.97v12.29Zm13.58-12.29l-4.9,12.29h-1.93l-4.66-12.29h2.16l3.12,8.93c.23.66.38,1.23.43,1.72h.05c.08-.62.21-1.17.38-1.67l3.27-8.98h2.08Zm3.06-3.12c-.35,0-.65-.12-.9-.36-.25-.24-.37-.54-.37-.91s.12-.67.37-.91c.25-.25.55-.37.9-.37s.66.12.91.37c.26.24.38.54.38.91s-.13.65-.38.9c-.25.25-.55.37-.91.37Zm.96,15.41h-1.97v-12.29h1.97v12.29Zm14.12,0h-1.97v-7.01c0-2.61-.95-3.91-2.86-3.91-.98,0-1.8.37-2.45,1.12-.64.74-.96,1.67-.96,2.8v7.01h-1.97v-12.29h1.97v2.04h.05c.93-1.55,2.27-2.33,4.03-2.33,1.34,0,2.37.44,3.09,1.31.71.86,1.07,2.12,1.07,3.76v7.52Zm14.14-.98c0,4.51-2.16,6.77-6.48,6.77-1.52,0-2.85-.29-3.99-.86v-1.97c1.38.77,2.71,1.15,3.96,1.15,3.03,0,4.54-1.61,4.54-4.83v-1.34h-.05c-.94,1.57-2.35,2.35-4.23,2.35-1.53,0-2.76-.54-3.7-1.63-.93-1.1-1.39-2.57-1.39-4.41,0-2.09.5-3.75,1.5-4.98,1.01-1.23,2.39-1.85,4.13-1.85s2.89.66,3.69,1.99h.05v-1.7h1.97v11.31Zm-1.97-4.57v-1.81c0-.98-.33-1.81-1-2.51-.66-.7-1.48-1.04-2.46-1.04-1.22,0-2.17.44-2.86,1.33-.69.88-1.03,2.12-1.03,3.71,0,1.37.33,2.47.98,3.29.66.82,1.54,1.22,2.63,1.22s2-.39,2.69-1.18c.7-.78,1.04-1.79,1.04-3.01Z" />
				<path d="m535.13,299h-2.4l-2.88-4.83c-.26-.45-.52-.83-.77-1.14-.25-.32-.5-.58-.77-.78-.26-.2-.54-.34-.84-.43-.3-.1-.63-.14-1.01-.14h-1.66v7.32h-2.02v-17.22h5.14c.75,0,1.44.1,2.08.29.64.18,1.19.47,1.66.85.47.38.84.86,1.1,1.44.26.57.4,1.24.4,2,0,.6-.09,1.15-.28,1.66-.18.5-.43.94-.77,1.33-.33.39-.73.73-1.2,1.01-.46.27-.99.48-1.57.64v.05c.29.13.54.28.74.44.22.16.42.35.61.58.19.22.38.48.56.77.19.28.4.61.64.98l3.23,5.17Zm-10.32-15.39v6.24h2.74c.5,0,.97-.08,1.39-.23.43-.15.8-.37,1.12-.65.31-.29.56-.64.73-1.04.18-.42.26-.88.26-1.39,0-.92-.3-1.64-.9-2.15-.59-.52-1.45-.78-2.58-.78h-2.76Zm17.5,15.68c-1.82,0-3.27-.57-4.36-1.72-1.08-1.15-1.62-2.68-1.62-4.57,0-2.06.56-3.68,1.69-4.84,1.13-1.16,2.65-1.74,4.57-1.74s3.26.56,4.29,1.69c1.03,1.13,1.55,2.69,1.55,4.69s-.56,3.53-1.67,4.72c-1.1,1.18-2.59,1.76-4.45,1.76Zm.14-11.21c-1.26,0-2.26.43-3,1.3-.74.86-1.1,2.04-1.1,3.55s.37,2.61,1.12,3.45c.74.84,1.74,1.26,2.99,1.26s2.25-.41,2.93-1.24c.69-.82,1.03-2,1.03-3.52s-.34-2.72-1.03-3.55c-.68-.83-1.66-1.25-2.93-1.25Zm14.2,11.21c-1.82,0-3.27-.57-4.36-1.72-1.08-1.15-1.62-2.68-1.62-4.57,0-2.06.56-3.68,1.69-4.84,1.13-1.16,2.65-1.74,4.57-1.74s3.26.56,4.29,1.69c1.03,1.13,1.55,2.69,1.55,4.69s-.56,3.53-1.67,4.72c-1.1,1.18-2.59,1.76-4.45,1.76Zm.14-11.21c-1.26,0-2.26.43-3,1.3-.74.86-1.1,2.04-1.1,3.55s.37,2.61,1.12,3.45c.74.84,1.74,1.26,2.99,1.26s2.25-.41,2.93-1.24c.69-.82,1.03-2,1.03-3.52s-.34-2.72-1.03-3.55c-.68-.83-1.66-1.25-2.93-1.25Zm26.52,10.92h-1.97v-7.06c0-1.36-.21-2.35-.64-2.95-.42-.61-1.12-.91-2.11-.91-.84,0-1.56.38-2.15,1.15-.58.77-.88,1.69-.88,2.76v7.01h-1.97v-7.3c0-2.42-.93-3.63-2.8-3.63-.86,0-1.58.36-2.14,1.09-.56.72-.84,1.66-.84,2.82v7.01h-1.97v-12.29h1.97v1.94h.05c.87-1.49,2.15-2.23,3.82-2.23.84,0,1.57.24,2.2.71.62.46,1.05,1.08,1.28,1.84.91-1.7,2.27-2.55,4.08-2.55,2.71,0,4.06,1.67,4.06,5.01v7.58Z" />
				<path d="m473.96,321.03c0-.33.05-.66.16-1,.1-.34.25-.65.45-.94.2-.29.44-.56.73-.79.29-.24.62-.43.99-.57-.54-.3-.97-.69-1.29-1.16-.32-.48-.48-1-.48-1.58,0-.46.09-.89.26-1.28.18-.39.43-.73.74-1.01.31-.29.69-.51,1.12-.66.43-.16.9-.24,1.4-.24s.98.08,1.41.24c.43.16.8.39,1.12.67.31.29.56.62.73,1.01.17.39.26.81.26,1.27,0,.58-.16,1.1-.48,1.58-.32.47-.75.86-1.28,1.16.36.14.68.33.97.57.29.24.52.5.72.79.2.29.35.61.45.94.1.33.16.66.16,1,0,.55-.1,1.05-.3,1.5-.2.45-.48.84-.84,1.17-.36.32-.78.57-1.28.75-.49.18-1.04.27-1.64.27s-1.14-.09-1.63-.27-.92-.43-1.28-.75c-.36-.33-.64-.72-.85-1.17-.2-.45-.3-.96-.3-1.5Zm1.55-.12c0,.39.06.74.17,1.06.12.31.29.58.51.8.22.22.49.39.79.52.31.12.66.17,1.04.17s.7-.06,1.01-.18c.31-.12.57-.29.79-.52.23-.22.4-.49.52-.8.13-.31.19-.66.19-1.05,0-.35-.06-.68-.18-.98-.12-.31-.29-.58-.51-.81-.22-.23-.49-.42-.79-.55-.31-.13-.66-.2-1.04-.2-.36,0-.7.06-1,.19-.3.12-.57.3-.79.52-.22.22-.4.49-.52.8-.13.31-.19.65-.19,1.02Zm.45-5.81c0,.3.05.57.16.83.11.25.26.47.45.66.19.19.41.33.66.45.25.1.52.16.8.16s.55-.06.8-.17c.26-.11.48-.26.66-.45.19-.19.33-.41.45-.66.11-.26.17-.53.17-.82s-.06-.58-.17-.84c-.1-.26-.25-.48-.44-.66-.19-.19-.41-.33-.66-.44-.25-.11-.52-.17-.81-.17-.31,0-.59.06-.85.17-.25.11-.47.26-.66.45-.18.19-.32.41-.42.66-.1.26-.15.53-.15.82Z" />
				<rect x="484.26" y="311.99" width="1.27" height="3.9" />
				<path d="m494.32,311.99v8.27h1.61v1.31h-1.61v2.94h-1.42v-2.94h-5.89v-1.24c.55-.62,1.1-1.28,1.66-1.97.56-.7,1.09-1.42,1.6-2.14.51-.72.98-1.44,1.42-2.16.44-.72.8-1.41,1.1-2.07h1.53Zm-5.69,8.27h4.27v-6.13c-.44.76-.85,1.44-1.24,2.04-.39.6-.76,1.14-1.12,1.63-.35.49-.68.93-1,1.33-.32.4-.62.77-.91,1.13Z" />
				<path d="m499.24,311.99v3.9h-1.27v-3.9h1.27Zm2.9,0v3.9h-1.27v-3.9h1.27Z" />
				<path d="m516.46,315.58l-3,4.52,2.95,4.42h-1.67l-1.76-2.9c-.11-.18-.24-.41-.39-.68h-.03c-.03.05-.17.28-.41.68l-1.79,2.9h-1.65l3.05-4.38-2.92-4.56h1.67l1.73,3.06c.13.23.25.46.38.7h.03l2.24-3.76h1.58Z" />
				<path d="m527.91,324.52h-1.43v-10.82c-.11.11-.27.24-.49.38-.21.14-.45.28-.72.42-.26.14-.54.27-.84.39-.29.12-.58.22-.86.29v-1.45c.31-.09.65-.2,1-.35.36-.15.7-.32,1.04-.5.34-.19.67-.38.97-.58.3-.2.56-.4.79-.59h.54v12.81Zm10.08-9.24c0-.38-.06-.72-.18-1-.12-.29-.28-.52-.49-.71-.2-.19-.45-.33-.73-.43-.28-.09-.58-.14-.91-.14-.28,0-.55.04-.82.11-.27.08-.53.18-.79.31-.25.13-.49.29-.73.48-.23.19-.45.39-.66.62v-1.54c.4-.39.85-.69,1.35-.89.5-.21,1.11-.31,1.83-.31.51,0,.99.08,1.42.23.44.15.82.36,1.14.65s.57.64.75,1.06c.19.42.28.9.28,1.44,0,.49-.06.94-.17,1.35-.11.4-.28.78-.52,1.14-.23.36-.52.7-.86,1.02-.35.33-.76.66-1.23,1-.59.42-1.07.78-1.46,1.07-.38.3-.68.58-.91.84-.22.26-.38.52-.47.78-.09.26-.13.55-.13.89h6.24v1.28h-7.73v-.62c0-.54.06-1.01.17-1.42.12-.41.31-.79.58-1.16.27-.37.62-.73,1.05-1.1.44-.37.97-.78,1.6-1.24.45-.33.83-.64,1.14-.93.31-.3.56-.59.74-.89.19-.3.32-.6.39-.9.08-.31.12-.63.12-.98Z" />
				<rect x="542.33" y="311.99" width="1.27" height="3.9" />
				<path d="m552.38,311.99v8.27h1.61v1.31h-1.61v2.94h-1.42v-2.94h-5.89v-1.24c.55-.62,1.1-1.28,1.66-1.97.56-.7,1.09-1.42,1.6-2.14.51-.72.98-1.44,1.42-2.16.44-.72.8-1.41,1.1-2.07h1.53Zm-5.69,8.27h4.27v-6.13c-.44.76-.85,1.44-1.24,2.04-.39.6-.76,1.14-1.12,1.63-.35.49-.68.93-1,1.33-.32.4-.62.77-.91,1.13Z" />
				<path d="m557.31,311.99v3.9h-1.27v-3.9h1.27Zm2.9,0v3.9h-1.27v-3.9h1.27Z" />
				<path d="m248.45,803.37h-9.12v-17.22h8.74v1.82h-6.72v5.73h6.22v1.81h-6.22v6.03h7.11v1.82Zm13.28,0h-1.97v-7.01c0-2.61-.95-3.91-2.86-3.91-.98,0-1.8.37-2.45,1.12-.64.74-.96,1.67-.96,2.8v7.01h-1.97v-12.29h1.97v2.04h.05c.93-1.55,2.27-2.33,4.03-2.33,1.34,0,2.37.44,3.09,1.31.71.86,1.07,2.12,1.07,3.76v7.52Zm9.44-.12c-.46.26-1.08.38-1.84.38-2.15,0-3.23-1.2-3.23-3.6v-7.28h-2.11v-1.68h2.11v-3l1.97-.64v3.64h3.1v1.68h-3.1v6.93c0,.82.14,1.41.42,1.76s.74.53,1.39.53c.5,0,.92-.14,1.28-.41v1.68Zm9.06-10.18c-.34-.26-.84-.4-1.49-.4-.84,0-1.54.4-2.11,1.19-.56.79-.84,1.87-.84,3.24v6.27h-1.97v-12.29h1.97v2.53h.05c.28-.86.71-1.54,1.28-2.02.58-.49,1.22-.73,1.93-.73.51,0,.9.06,1.18.17v2.04Zm11.95-1.99l-5.65,14.26c-1.01,2.55-2.43,3.82-4.25,3.82-.51,0-.94-.05-1.28-.16v-1.76c.42.14.81.22,1.16.22.99,0,1.74-.59,2.23-1.78l.98-2.33-4.8-12.27h2.18l3.33,9.46c.04.12.12.43.25.94h.07c.04-.19.12-.5.24-.91l3.49-9.48h2.04Z" />
				<path d="m736.29,320.94v-17.22h4.9c1.49,0,2.67.36,3.54,1.09.87.73,1.31,1.68,1.31,2.85,0,.98-.26,1.82-.79,2.55-.53.72-1.26,1.23-2.18,1.54v.05c1.16.14,2.09.58,2.79,1.32.7.74,1.04,1.7,1.04,2.88,0,1.47-.53,2.67-1.58,3.58-1.06.91-2.39,1.37-4,1.37h-5.02Zm2.02-15.39v5.56h2.06c1.1,0,1.97-.26,2.61-.79.63-.54.95-1.29.95-2.26,0-1.67-1.1-2.51-3.3-2.51h-2.32Zm0,7.37v6.19h2.74c1.18,0,2.1-.28,2.75-.84.66-.56.98-1.33.98-2.3,0-2.03-1.38-3.05-4.15-3.05h-2.32Zm21.67,2.37h-8.68c.03,1.37.4,2.43,1.1,3.17.7.74,1.67,1.12,2.91,1.12,1.38,0,2.66-.46,3.82-1.37v1.85c-1.08.78-2.51,1.18-4.29,1.18s-3.1-.56-4.09-1.67c-.99-1.12-1.49-2.69-1.49-4.72,0-1.91.54-3.47,1.62-4.67,1.09-1.21,2.44-1.81,4.05-1.81s2.85.52,3.73,1.56,1.32,2.49,1.32,4.33v1.03Zm-2.02-1.67c0-1.14-.28-2.02-.83-2.65-.54-.63-1.28-.95-2.24-.95s-1.72.33-2.37,1c-.65.66-1.05,1.53-1.2,2.61h6.64Zm15.47,7.32h-1.97v-2.09h-.05c-.91,1.58-2.32,2.38-4.23,2.38-1.54,0-2.78-.55-3.71-1.64-.92-1.1-1.38-2.61-1.38-4.5,0-2.03.51-3.66,1.54-4.89,1.02-1.22,2.39-1.84,4.09-1.84s2.92.66,3.69,1.99h.05v-7.61h1.97v18.2Zm-1.97-5.56v-1.81c0-.99-.33-1.83-.98-2.52-.66-.69-1.49-1.03-2.5-1.03-1.2,0-2.14.44-2.83,1.32s-1.03,2.1-1.03,3.65c0,1.42.33,2.54.98,3.36.66.82,1.55,1.22,2.67,1.22s1.98-.4,2.67-1.19c.69-.79,1.03-1.79,1.03-3Zm12.35-4.74c-.34-.26-.84-.4-1.49-.4-.84,0-1.54.4-2.11,1.19-.56.79-.84,1.87-.84,3.24v6.27h-1.97v-12.29h1.97v2.53h.05c.28-.86.71-1.54,1.28-2.02.58-.49,1.22-.73,1.93-.73.51,0,.9.06,1.18.17v2.04Zm7.26,10.59c-1.82,0-3.27-.57-4.36-1.72-1.08-1.15-1.62-2.68-1.62-4.57,0-2.06.56-3.68,1.69-4.84,1.13-1.16,2.65-1.74,4.57-1.74s3.26.56,4.29,1.69c1.03,1.13,1.55,2.69,1.55,4.69s-.56,3.53-1.67,4.72c-1.1,1.18-2.59,1.76-4.45,1.76Zm.14-11.21c-1.26,0-2.26.43-3,1.3-.74.86-1.1,2.04-1.1,3.55s.37,2.61,1.12,3.45c.74.84,1.74,1.26,2.99,1.26s2.25-.41,2.93-1.24c.69-.82,1.03-2,1.03-3.52s-.34-2.72-1.03-3.55c-.68-.83-1.66-1.25-2.93-1.25Zm14.25,11.21c-1.82,0-3.27-.57-4.36-1.72-1.08-1.15-1.62-2.68-1.62-4.57,0-2.06.56-3.68,1.69-4.84,1.13-1.16,2.65-1.74,4.57-1.74s3.26.56,4.29,1.69c1.03,1.13,1.55,2.69,1.55,4.69s-.56,3.53-1.67,4.72c-1.1,1.18-2.59,1.76-4.45,1.76Zm.14-11.21c-1.26,0-2.26.43-3,1.3-.74.86-1.1,2.04-1.1,3.55s.37,2.61,1.12,3.45c.74.84,1.74,1.26,2.99,1.26s2.25-.41,2.93-1.24c.69-.82,1.03-2,1.03-3.52s-.34-2.72-1.03-3.55c-.68-.83-1.66-1.25-2.93-1.25Zm26.56,10.92h-1.97v-7.06c0-1.36-.21-2.34-.64-2.95-.42-.61-1.12-.91-2.11-.91-.84,0-1.56.38-2.15,1.15-.58.77-.88,1.69-.88,2.76v7.01h-1.97v-7.3c0-2.42-.93-3.63-2.8-3.63-.86,0-1.58.36-2.14,1.09-.56.72-.84,1.66-.84,2.82v7.01h-1.97v-12.29h1.97v1.94h.05c.87-1.49,2.15-2.23,3.82-2.23.84,0,1.57.24,2.2.71.62.46,1.05,1.08,1.28,1.84.91-1.7,2.27-2.55,4.08-2.55,2.71,0,4.06,1.67,4.06,5.01v7.58Z" />
				<path d="m741.22,346.46h-1.43v-10.82c-.11.11-.27.24-.49.38-.21.14-.45.28-.72.42-.26.14-.54.27-.84.39-.29.12-.58.22-.86.29v-1.45c.31-.09.65-.2,1-.35.36-.15.7-.32,1.04-.5.34-.19.67-.38.97-.58.3-.2.56-.4.79-.59h.54v12.81Zm9.66,0h-1.43v-10.82c-.11.11-.27.24-.49.38-.21.14-.45.28-.72.42-.26.14-.54.27-.84.39-.29.12-.58.22-.86.29v-1.45c.31-.09.65-.2,1-.35.36-.15.7-.32,1.04-.5.34-.19.67-.38.97-.58.3-.2.56-.4.79-.59h.54v12.81Z" />
				<rect x="755.64" y="333.94" width="1.27" height="3.9" />
				<path d="m767.17,340.15c0,1.05-.1,1.98-.29,2.79-.19.81-.46,1.49-.82,2.05-.36.55-.79.98-1.32,1.27-.52.29-1.11.43-1.77.43-.63,0-1.19-.14-1.69-.41-.49-.28-.9-.68-1.24-1.21-.34-.53-.59-1.18-.77-1.95-.17-.77-.26-1.66-.26-2.66,0-1.09.09-2.06.27-2.9.19-.84.46-1.54.81-2.11.36-.57.79-1,1.32-1.28.53-.29,1.14-.44,1.82-.44,2.63,0,3.94,2.14,3.94,6.42Zm-1.47.14c0-3.56-.85-5.35-2.54-5.35-1.79,0-2.68,1.81-2.68,5.44,0,3.38.88,5.07,2.63,5.07s2.59-1.72,2.59-5.17Z" />
				<path d="m770.61,333.94v3.9h-1.27v-3.9h1.27Zm2.9,0v3.9h-1.27v-3.9h1.27Z" />
				<path d="m787.83,337.52l-3,4.52,2.95,4.42h-1.67l-1.76-2.9c-.11-.18-.24-.41-.39-.68h-.03c-.03.05-.17.28-.41.68l-1.79,2.9h-1.65l3.05-4.38-2.92-4.56h1.67l1.73,3.06c.13.23.25.46.38.7h.03l2.24-3.76h1.58Z" />
				<path d="m799.29,346.46h-1.43v-10.82c-.11.11-.27.24-.49.38-.21.14-.45.28-.72.42-.26.14-.54.27-.84.39-.29.12-.58.22-.86.29v-1.45c.31-.09.65-.2,1-.35.36-.15.7-.32,1.04-.5.34-.19.67-.38.97-.58.3-.2.56-.4.79-.59h.54v12.81Zm10.76-12.53v8.27h1.61v1.31h-1.61v2.94h-1.42v-2.94h-5.89v-1.24c.55-.62,1.1-1.28,1.66-1.97.56-.7,1.09-1.42,1.6-2.14.51-.72.98-1.44,1.42-2.16.44-.72.8-1.41,1.1-2.07h1.53Zm-5.69,8.27h4.27v-6.13c-.44.76-.85,1.44-1.24,2.04-.39.6-.76,1.14-1.12,1.63-.35.49-.68.93-1,1.33-.32.4-.62.77-.91,1.13Z" />
				<rect x="813.7" y="333.94" width="1.27" height="3.9" />
				<path d="m825.16,334.77c-.19.33-.43.75-.7,1.24-.27.49-.55,1.05-.86,1.67-.3.62-.61,1.28-.93,1.99s-.61,1.44-.88,2.2-.52,1.53-.72,2.31c-.2.77-.35,1.54-.45,2.29h-1.54c.1-.75.26-1.51.48-2.28.22-.78.47-1.54.74-2.29.28-.75.57-1.47.88-2.17.31-.69.61-1.33.9-1.91.29-.58.56-1.09.79-1.54.24-.45.44-.8.59-1.05h-6.28v-1.29h7.97v.83Z" />
				<path d="m828.68,333.94v3.9h-1.27v-3.9h1.27Zm2.9,0v3.9h-1.27v-3.9h1.27Z" />
				<path d="m207.1,622.52h-2.81l-6.65-7.88c-.25-.3-.4-.5-.46-.6h-.05v8.48h-2.02v-17.22h2.02v8.09h.05c.11-.18.26-.37.46-.59l6.43-7.5h2.51l-7.38,8.26,7.9,8.96Zm3.01-15.41c-.35,0-.65-.12-.9-.36-.25-.24-.37-.54-.37-.91s.12-.67.37-.91c.25-.25.55-.37.9-.37s.66.12.91.37c.26.24.38.54.38.91s-.13.65-.38.9c-.25.25-.55.37-.91.37Zm.96,15.41h-1.97v-12.29h1.97v12.29Zm9.67-.12c-.46.26-1.08.38-1.84.38-2.15,0-3.23-1.2-3.23-3.6v-7.28h-2.11v-1.68h2.11v-3l1.97-.64v3.64h3.1v1.68h-3.1v6.93c0,.82.14,1.41.42,1.76.28.35.74.53,1.39.53.5,0,.92-.14,1.28-.41v1.68Zm11-.44c-.94.57-2.06.85-3.36.85-1.75,0-3.17-.57-4.25-1.7-1.07-1.14-1.61-2.63-1.61-4.44,0-2.02.58-3.65,1.74-4.87,1.16-1.23,2.71-1.85,4.65-1.85,1.08,0,2.03.2,2.86.6v2.02c-.91-.64-1.89-.96-2.93-.96-1.26,0-2.29.45-3.1,1.36-.8.9-1.2,2.08-1.2,3.54s.38,2.58,1.13,3.41c.76.83,1.78,1.25,3.05,1.25,1.07,0,2.08-.36,3.03-1.07v1.87Zm13.17.56h-1.97v-7.08c0-2.56-.95-3.84-2.86-3.84-.96,0-1.77.37-2.43,1.12-.66.74-.98,1.68-.98,2.85v6.96h-1.97v-18.2h1.97v7.95h.05c.94-1.55,2.29-2.33,4.03-2.33,2.77,0,4.15,1.67,4.15,5.01v7.58Zm13.58-5.65h-8.68c.03,1.37.4,2.43,1.1,3.17.7.74,1.67,1.12,2.91,1.12,1.38,0,2.66-.46,3.82-1.37v1.85c-1.08.78-2.51,1.18-4.29,1.18s-3.1-.56-4.09-1.67c-.99-1.12-1.49-2.69-1.49-4.72,0-1.91.54-3.47,1.62-4.67,1.09-1.21,2.44-1.81,4.05-1.81s2.85.52,3.73,1.56,1.32,2.49,1.32,4.33v1.03Zm-2.02-1.67c0-1.14-.28-2.02-.83-2.65-.54-.63-1.28-.95-2.24-.95s-1.72.33-2.37,1c-.65.66-1.05,1.53-1.2,2.61h6.64Zm15.19,7.32h-1.97v-7.01c0-2.61-.95-3.91-2.86-3.91-.98,0-1.8.37-2.45,1.12-.64.74-.96,1.67-.96,2.8v7.01h-1.97v-12.29h1.97v2.04h.05c.93-1.55,2.27-2.33,4.03-2.33,1.34,0,2.37.44,3.09,1.31.71.86,1.07,2.12,1.07,3.76v7.52Z" />
				<path d="m647.35,726.07l-3.1,10.96h-1.51l-2.25-8.01c-.1-.34-.16-.71-.18-1.12h-.03c-.03.38-.1.74-.2,1.1l-2.27,8.02h-1.49l-3.21-10.96h1.41l2.33,8.41c.1.35.16.72.18,1.1h.04c.03-.27.1-.64.24-1.1l2.42-8.41h1.23l2.32,8.47c.08.29.14.63.18,1.02h.03c.02-.26.09-.62.21-1.05l2.24-8.44h1.39Z" />
				<polygon points="653.74 726.07 648.49 738.84 647.32 738.84 652.56 726.07 653.74 726.07" />
				<path d="m655.02,737.02v-10.96h3.03c3.86,0,5.79,1.78,5.79,5.34,0,1.69-.54,3.05-1.61,4.08-1.07,1.02-2.5,1.54-4.3,1.54h-2.9Zm1.28-9.8v8.64h1.64c1.44,0,2.55-.38,3.35-1.15s1.2-1.86,1.2-3.27c0-2.81-1.49-4.21-4.48-4.21h-1.71Z" />
			</g>
		</g>
	)
}

export default PlanW
